// // // // // // import React, { useEffect, useState } from 'react';
// // // // // // import { useNavigate } from 'react-router-dom';
// // // // // // import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// // // // // // import axios from 'axios';

// // // // // // const MenuAdvertisement = () => {
// // // // // //     const navigate = useNavigate();
// // // // // //     const [menuData, setMenuData] = useState({});
// // // // // //     const [loading, setLoading] = useState(true);

// // // // // //     useEffect(() => {
// // // // // //         const fetchMenuData = async () => {
// // // // // //             const vendorId = localStorage.getItem("vendorId");
// // // // // //             const token = localStorage.getItem("authToken");

// // // // // //             if (!vendorId || !token) {
// // // // // //                 console.warn("Missing vendorId or token");
// // // // // //                 setLoading(false);
// // // // // //                 return;
// // // // // //             }

// // // // // //             try {
// // // // // //                 // Fetch all dishes
// // // // // //                 const response = await axios.get(
// // // // // //                     `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
// // // // // //                     {
// // // // // //                         headers: {
// // // // // //                             'Authorization': `Bearer ${token}`,
// // // // // //                             'Content-Type': 'application/json'
// // // // // //                         }
// // // // // //                     }
// // // // // //                 );

// // // // // //                 const allItems = response.data;

// // // // // //                 // Separate categories (parentId: 0) and dishes (parentId: categoryId)
// // // // // //                 const categories = allItems.filter(item => item.parentId === 0);

// // // // // //                 // Filter dishes - only include those with stockQuantity > 0 AND menuStatus "Enable"
// // // // // //                 const dishes = allItems.filter(item => 
// // // // // //                     item.parentId !== 0 && 
// // // // // //                     item.menuStatus === "Enable" && 
// // // // // //                     item.stockQuantity > 0  // Only show items with stock
// // // // // //                 );

// // // // // //                 // Group dishes under their respective categories
// // // // // //                 const groupedMenu = {};

// // // // // //                 categories.forEach(category => {
// // // // // //                     // Find all dishes that belong to this category
// // // // // //                     const categoryDishes = dishes.filter(
// // // // // //                         dish => dish.parentId === category.dishId
// // // // // //                     );

// // // // // //                     // Only add category if it has dishes
// // // // // //                     if (categoryDishes.length > 0) {
// // // // // //                         groupedMenu[category.dishName] = categoryDishes;
// // // // // //                     }
// // // // // //                 });

// // // // // //                 setMenuData(groupedMenu);
// // // // // //                 setLoading(false);

// // // // // //             } catch (error) {
// // // // // //                 console.error("Error fetching menu data:", error);
// // // // // //                 setLoading(false);
// // // // // //             }
// // // // // //         };

// // // // // //         fetchMenuData();
// // // // // //     }, []);

// // // // // //     const handleBack = () => {
// // // // // //         navigate('/fooddashboard');
// // // // // //     };

// // // // // //     if (loading) {
// // // // // //         return (
// // // // // //             <div style={{
// // // // // //                 display: 'flex',
// // // // // //                 justifyContent: 'center',
// // // // // //                 alignItems: 'center',
// // // // // //                 minHeight: '100vh',
// // // // // //                 background: '#fff9f0'
// // // // // //             }}>
// // // // // //                 <div style={{ textAlign: 'center' }}>
// // // // // //                     <div style={{
// // // // // //                         width: '40px',
// // // // // //                         height: '40px',
// // // // // //                         border: '3px solid #f3f3f3',
// // // // // //                         borderTop: '3px solid #b15cd6',
// // // // // //                         borderRadius: '50%',
// // // // // //                         animation: 'spin 1s linear infinite',
// // // // // //                         margin: '0 auto 15px'
// // // // // //                     }}></div>
// // // // // //                     <p>Loading menu...</p>
// // // // // //                 </div>
// // // // // //             </div>
// // // // // //         );
// // // // // //     }

// // // // // //     return (
// // // // // //         <div style={{
// // // // // //             minHeight: '100vh',
// // // // // //             background: '#f3eadf',
// // // // // //             padding: '30px',
// // // // // //         }}>

// // // // // //             {/* Back Button */}
// // // // // //             <button
// // // // // //                 onClick={handleBack}
// // // // // //                 style={{
// // // // // //                     position: 'fixed',
// // // // // //                     top: '20px',
// // // // // //                     left: '20px',
// // // // // //                     background: '#8b0000',
// // // // // //                     color: '#fff',
// // // // // //                     border: 'none',
// // // // // //                     borderRadius: '50%',
// // // // // //                     width: '38px',
// // // // // //                     height: '38px',
// // // // // //                     cursor: 'pointer',
// // // // // //                     zIndex: 1000
// // // // // //                 }}
// // // // // //             >
// // // // // //                 <ArrowBackIcon />
// // // // // //             </button>

// // // // // //             {/* MENU PAPER */}
// // // // // //             <div style={{
// // // // // //                 margin: '0',
// // // // // //                 background: '#fffaf2',
// // // // // //                 padding: '35px 40px',
// // // // // //             }}>

// // // // // //                 {/* NEWSPAPER COLUMN FLOW */}
// // // // // //                 <div style={{
// // // // // //                     columnCount: 3,
// // // // // //                     columnGap: '60px'
// // // // // //                 }}>

// // // // // //                     {Object.entries(menuData).map(([categoryName, items]) => (
// // // // // //                         <div
// // // // // //                             key={categoryName}
// // // // // //                             style={{
// // // // // //                                 breakInside: 'avoid',
// // // // // //                                 marginBottom: '26px'
// // // // // //                             }}
// // // // // //                         >
// // // // // //                             {/* CATEGORY */}
// // // // // //                             <div style={{
// // // // // //                                 fontWeight: 'bold',
// // // // // //                                 fontSize: '18px',
// // // // // //                                 marginBottom: '10px',
// // // // // //                                 borderBottom: '1px solid #000',
// // // // // //                                 paddingBottom: '4px',
// // // // // //                                 textTransform: 'uppercase'
// // // // // //                             }}>
// // // // // //                                 {categoryName}
// // // // // //                             </div>

// // // // // //                             {/* HEADERS - Items, Quantity, Price */}
// // // // // //                             <div style={{
// // // // // //                                 display: 'flex',
// // // // // //                                 marginBottom: '8px',
// // // // // //                                 fontSize: '14px',
// // // // // //                                 fontWeight: 'bold',
// // // // // //                                 borderBottom: '1px dashed #000',
// // // // // //                                 paddingBottom: '4px',
// // // // // //                                 color: '#555'
// // // // // //                             }}>
// // // // // //                                 <div style={{ width:"10vw"}}>Items</div>
// // // // // //                                 <div style={{ width: '10vw', textAlign: 'center' }}>Qty</div>
// // // // // //                                 <div style={{ width: '55px', textAlign: 'right' }}>Price</div>
// // // // // //                             </div>

// // // // // //                             {/* ITEMS - Only showing items with stock > 0 (already filtered) */}
// // // // // //                             {items.map(item => (
// // // // // //                                 <div
// // // // // //                                     key={item.dishId}
// // // // // //                                     style={{
// // // // // //                                         display: 'flex',
// // // // // //                                         alignItems: 'flex-start',
// // // // // //                                         marginBottom: '6px',
// // // // // //                                         fontSize: '15px'
// // // // // //                                     }}
// // // // // //                                 >
// // // // // //                                     {/* Dish Name - Column 1 */}
// // // // // //                                     <div style={{
// // // // // //                                         width:"10vw",
// // // // // //                                         paddingRight: '10px',
// // // // // //                                         lineHeight: '1.3'
// // // // // //                                     }}>
// // // // // //                                         <span style={{ marginRight: '6px' }}>
// // // // // //                                             {item.tag === "Veg" && <span style={{ color: 'green' }}>●</span>}
// // // // // //                                             {item.tag === "Non_Veg" && <span style={{ color: 'red' }}>●</span>}
// // // // // //                                         </span>
// // // // // //                                         {item.dishName}
// // // // // //                                     </div>

// // // // // //                                     {/* Quantity - Column 2 (using stockQuantity field) */}
// // // // // //                                     <div style={{
// // // // // //                                         width:"10vw",
// // // // // //                                         textAlign: 'center',
// // // // // //                                         whiteSpace: 'nowrap'
// // // // // //                                     }}>
// // // // // //                                         {item.stockQuantity}
// // // // // //                                     </div>

// // // // // //                                     {/* Price - Column 3 */}
// // // // // //                                     <div style={{
// // // // // //                                         width: '55px',
// // // // // //                                         textAlign: 'right',
// // // // // //                                         whiteSpace: 'nowrap'
// // // // // //                                     }}>
// // // // // //                                         {item.price > item.effectivePrice ? (
// // // // // //                                             <span style={{ color: '#8b0000', fontWeight: 'bold' }}>
// // // // // //                                                 ₹{item.effectivePrice}
// // // // // //                                             </span>
// // // // // //                                         ) : (
// // // // // //                                             <span style={{ fontWeight: 'bold' }}>
// // // // // //                                                 ₹{item.price}
// // // // // //                                             </span>
// // // // // //                                         )}
// // // // // //                                     </div>
// // // // // //                                 </div>
// // // // // //                             ))}
// // // // // //                         </div>
// // // // // //                     ))}
// // // // // //                 </div>
// // // // // //             </div>
// // // // // //         </div>
// // // // // //     );
// // // // // // };

// // // // // // export default MenuAdvertisement;



// // // // // // import React, { useEffect, useState, useRef } from 'react';
// // // // // // import { useNavigate } from 'react-router-dom';
// // // // // // import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// // // // // // import axios from 'axios';

// // // // // // const MenuAdvertisement = () => {
// // // // // //     const navigate = useNavigate();
// // // // // //     const [menuData, setMenuData] = useState({});
// // // // // //     const [loading, setLoading] = useState(true);
// // // // // //     const scrollContainerRef = useRef(null);
// // // // // //     const [refreshKey, setRefreshKey] = useState(0);

// // // // // //     useEffect(() => {
// // // // // //         const fetchMenuData = async () => {
// // // // // //             const vendorId = localStorage.getItem("vendorId");
// // // // // //             const token = localStorage.getItem("authToken");

// // // // // //             if (!vendorId || !token) {
// // // // // //                 console.warn("Missing vendorId or token");
// // // // // //                 setLoading(false);
// // // // // //                 return;
// // // // // //             }

// // // // // //             try {
// // // // // //                 // Fetch all dishes
// // // // // //                 const response = await axios.get(
// // // // // //                     `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
// // // // // //                     {
// // // // // //                         headers: {
// // // // // //                             'Authorization': `Bearer ${token}`,
// // // // // //                             'Content-Type': 'application/json'
// // // // // //                         }
// // // // // //                     }
// // // // // //                 );

// // // // // //                 const allItems = response.data;

// // // // // //                 // Separate categories (parentId: 0) and dishes (parentId: categoryId)
// // // // // //                 const categories = allItems.filter(item => item.parentId === 0);

// // // // // //                 // Filter dishes - only include those with stockQuantity > 0 AND menuStatus "Enable"
// // // // // //                 const dishes = allItems.filter(item =>
// // // // // //                     item.parentId !== 0 &&
// // // // // //                     item.menuStatus === "Enable" &&
// // // // // //                     item.stockQuantity > 0
// // // // // //                 );

// // // // // //                 // Group dishes under their respective categories
// // // // // //                 const groupedMenu = {};

// // // // // //                 categories.forEach(category => {
// // // // // //                     const categoryDishes = dishes.filter(
// // // // // //                         dish => dish.parentId === category.dishId
// // // // // //                     );

// // // // // //                     if (categoryDishes.length > 0) {
// // // // // //                         groupedMenu[category.dishName] = categoryDishes;
// // // // // //                     }
// // // // // //                 });

// // // // // //                 setMenuData(groupedMenu);
// // // // // //                 setLoading(false);

// // // // // //             } catch (error) {
// // // // // //                 console.error("Error fetching menu data:", error);
// // // // // //                 setLoading(false);
// // // // // //             }
// // // // // //         };

// // // // // //         fetchMenuData();
// // // // // //     }, [refreshKey]);


// // // // // //     // Auto-scroll effect
// // // // // //     useEffect(() => {
// // // // // //         const scrollContainer = scrollContainerRef.current;
// // // // // //         if (!scrollContainer || Object.keys(menuData).length === 0) return;

// // // // // //         let scrollInterval;
// // // // // //         let scrollingDown = true;

// // // // // //         const startAutoScroll = () => {
// // // // // //             scrollInterval = setInterval(() => {
// // // // // //                 if (scrollContainer) {
// // // // // //                     const maxScroll = scrollContainer.scrollHeight - scrollContainer.clientHeight;
// // // // // //                     const currentScroll = scrollContainer.scrollTop;

// // // // // //                     if (scrollingDown) {
// // // // // //                         // Scrolling down
// // // // // //                         if (currentScroll >= maxScroll - 2) {
// // // // // //                             // Reached bottom, start scrolling up
// // // // // //                             scrollingDown = false;
// // // // // //                             scrollContainer.scrollTop = maxScroll - 1;
// // // // // //                         } else {
// // // // // //                             scrollContainer.scrollTop += 1;
// // // // // //                         }
// // // // // //                     } else {
// // // // // //                         // Scrolling up
// // // // // //                         if (currentScroll <= 2) {
// // // // // //                             // Reached top, start scrolling down
// // // // // //                             scrollingDown = true;
// // // // // //                             scrollContainer.scrollTop = 1;
// // // // // //                         } else {
// // // // // //                             scrollContainer.scrollTop -= 1;
// // // // // //                         }
// // // // // //                     }
// // // // // //                 }
// // // // // //             }, 30); // <--- CHANGE THIS VALUE to adjust speed (lower = faster, higher = slower)
// // // // // //         };

// // // // // //         // Pause on hover
// // // // // //         const handleMouseEnter = () => {
// // // // // //             clearInterval(scrollInterval);
// // // // // //         };

// // // // // //         // Resume on mouse leave
// // // // // //         const handleMouseLeave = () => {
// // // // // //             startAutoScroll();
// // // // // //         };

// // // // // //         scrollContainer.addEventListener('mouseenter', handleMouseEnter);
// // // // // //         scrollContainer.addEventListener('mouseleave', handleMouseLeave);

// // // // // //         startAutoScroll();

// // // // // //         return () => {
// // // // // //             clearInterval(scrollInterval);
// // // // // //             if (scrollContainer) {
// // // // // //                 scrollContainer.removeEventListener('mouseenter', handleMouseEnter);
// // // // // //                 scrollContainer.removeEventListener('mouseleave', handleMouseLeave);
// // // // // //             }
// // // // // //         };
// // // // // //     }, [menuData]);


// // // // // //     const handleBack = () => {
// // // // // //         navigate('/fooddashboard');
// // // // // //     };

// // // // // //     if (loading) {
// // // // // //         return (
// // // // // //             <div style={{
// // // // // //                 display: 'flex',
// // // // // //                 justifyContent: 'center',
// // // // // //                 alignItems: 'center',
// // // // // //                 minHeight: '100vh',
// // // // // //                 background: '#fff9f0'
// // // // // //             }}>
// // // // // //                 <div style={{ textAlign: 'center' }}>
// // // // // //                     <div style={{
// // // // // //                         width: '40px',
// // // // // //                         height: '40px',
// // // // // //                         border: '3px solid #f3f3f3',
// // // // // //                         borderTop: '3px solid #b15cd6',
// // // // // //                         borderRadius: '50%',
// // // // // //                         animation: 'spin 1s linear infinite',
// // // // // //                         margin: '0 auto 15px'
// // // // // //                     }}></div>
// // // // // //                     <p>Loading menu...</p>
// // // // // //                 </div>
// // // // // //             </div>
// // // // // //         );
// // // // // //     }

// // // // // //     return (
// // // // // //         <div style={{
// // // // // //             minHeight: '100vh',
// // // // // //             background: '#f3eadf',
// // // // // //             padding: '30px',
// // // // // //         }}>

// // // // // //             {/* Back Button */}
// // // // // //             <button
// // // // // //                 onClick={handleBack}
// // // // // //                 style={{
// // // // // //                     position: 'fixed',
// // // // // //                     top: '20px',
// // // // // //                     left: '20px',
// // // // // //                     background: '#8b0000',
// // // // // //                     color: '#fff',
// // // // // //                     border: 'none',
// // // // // //                     borderRadius: '50%',
// // // // // //                     width: '38px',
// // // // // //                     height: '38px',
// // // // // //                     cursor: 'pointer',
// // // // // //                     zIndex: 1000,
// // // // // //                     display: 'flex',
// // // // // //                     alignItems: 'center',
// // // // // //                     justifyContent: 'center'
// // // // // //                 }}
// // // // // //             >
// // // // // //                 <ArrowBackIcon />
// // // // // //             </button>

// // // // // //             {/* MENU PAPER with Auto-scroll */}
// // // // // //             <div
// // // // // //                 ref={scrollContainerRef}
// // // // // //                 style={{
// // // // // //                     margin: '0',
// // // // // //                     background: '#fffaf2',
// // // // // //                     padding: '35px 40px',
// // // // // //                     maxHeight: 'calc(100vh - 5rem)',
// // // // // //                     overflowY: 'auto',
// // // // // //                     scrollBehavior: 'smooth',
// // // // // //                     position: 'relative',
// // // // // //                     scrollbarWidth: "none",
// // // // // //                 }}
// // // // // //             >


// // // // // //                 {/* NEWSPAPER COLUMN FLOW */}
// // // // // //                 <div style={{
// // // // // //                     columnCount: 3,
// // // // // //                     columnGap: '60px'
// // // // // //                 }}>

// // // // // //                     {Object.entries(menuData).map(([categoryName, items]) => (
// // // // // //                         <div
// // // // // //                             key={categoryName}
// // // // // //                             style={{
// // // // // //                                 breakInside: 'avoid',
// // // // // //                                 marginBottom: '26px'
// // // // // //                             }}
// // // // // //                         >
// // // // // //                             {/* CATEGORY */}
// // // // // //                             <div style={{
// // // // // //                                 fontWeight: 'bold',
// // // // // //                                 fontSize: '1.5rem',
// // // // // //                                 marginBottom: '10px',
// // // // // //                                 borderBottom: '1px solid #000',
// // // // // //                                 paddingBottom: '4px',
// // // // // //                                 textTransform: 'uppercase'
// // // // // //                             }}>
// // // // // //                                 {categoryName}
// // // // // //                             </div>

// // // // // //                             {/* HEADERS - Items, Quantity, Price */}
// // // // // //                             <div style={{
// // // // // //                                 display: 'flex',

// // // // // //                                 marginBottom: '8px',
// // // // // //                                 fontSize: '1.2rem',

// // // // // //                                 fontWeight: 'bold',
// // // // // //                                 borderBottom: '1px dashed #000',
// // // // // //                                 paddingBottom: '4px',
// // // // // //                                 color: '#555',
// // // // // //                                 justifyContent: "space-between"
// // // // // //                             }}>
// // // // // //                                 <div style={{}}>Items</div>
// // // // // //                                 {/* <div style={{ width: '10vw', textAlign: 'center' }}>Qty</div> */}
// // // // // //                                 <div style={{ width: '55px', textAlign: 'right' }}>Price</div>
// // // // // //                             </div>

// // // // // //                             {/* ITEMS */}
// // // // // //                             {items.map(item => (
// // // // // //                                 <div
// // // // // //                                     key={item.dishId}
// // // // // //                                     style={{
// // // // // //                                         display: 'flex',
// // // // // //                                         alignItems: 'flex-start',

// // // // // //                                         marginBottom: '6px',
// // // // // //                                         marginLeft: "1rem",
// // // // // //                                         marginRight: "1rem",
// // // // // //                                         fontSize: '1.4rem',
// // // // // //                                         justifyContent: "space-between",

// // // // // //                                     }}
// // // // // //                                 >
// // // // // //                                     {/* Dish Name - Column 1 with classic veg/non-veg box */}
// // // // // //                                     <div style={{
// // // // // //                                         // width: "10vw",
// // // // // //                                         paddingRight: '10px',
// // // // // //                                         lineHeight: '1.3',
// // // // // //                                         display: 'flex',
// // // // // //                                         alignItems: 'center',
// // // // // //                                         gap: '6px',

// // // // // //                                     }}>
// // // // // //                                         {/* Classic Veg/Non-Veg Box */}
// // // // // //                                         {item.tag === "Veg" && (
// // // // // //                                             <span style={{
// // // // // //                                                 display: 'inline-block',
// // // // // //                                                 width: '16px',
// // // // // //                                                 height: '16px',
// // // // // //                                                 border: '2px solid green',
// // // // // //                                                 borderRadius: '4px',
// // // // // //                                                 position: 'relative',
// // // // // //                                                 flexShrink: 0,
// // // // // //                                                 backgroundColor: 'transparent'
// // // // // //                                             }}>
// // // // // //                                                 <span style={{
// // // // // //                                                     position: 'absolute',
// // // // // //                                                     top: '3px',
// // // // // //                                                     left: '3px',
// // // // // //                                                     width: '6px',
// // // // // //                                                     height: '6px',
// // // // // //                                                     backgroundColor: 'green',
// // // // // //                                                     borderRadius: '50%'
// // // // // //                                                 }}></span>
// // // // // //                                             </span>
// // // // // //                                         )}
// // // // // //                                         {item.tag === "Non_Veg" && (
// // // // // //                                             <span style={{
// // // // // //                                                 display: 'inline-block',
// // // // // //                                                 width: '16px',
// // // // // //                                                 height: '16px',
// // // // // //                                                 border: '2px solid red',
// // // // // //                                                 borderRadius: '4px',
// // // // // //                                                 position: 'relative',
// // // // // //                                                 flexShrink: 0,
// // // // // //                                                 backgroundColor: 'transparent'
// // // // // //                                             }}>
// // // // // //                                                 <span style={{
// // // // // //                                                     position: 'absolute',
// // // // // //                                                     top: '3px',
// // // // // //                                                     left: '3px',
// // // // // //                                                     width: '6px',
// // // // // //                                                     height: '6px',
// // // // // //                                                     backgroundColor: 'red',
// // // // // //                                                     borderRadius: '50%'
// // // // // //                                                 }}></span>
// // // // // //                                             </span>
// // // // // //                                         )}

// // // // // //                                         {item.dishName}
// // // // // //                                     </div>

// // // // // //                                     {/* Quantity - Column 2 */}
// // // // // //                                     {/* <div style={{
// // // // // //                                         width: "10vw",
// // // // // //                                         textAlign: 'center',
// // // // // //                                         whiteSpace: 'nowrap'
// // // // // //                                     }}>
// // // // // //                                         {item.stockQuantity}
// // // // // //                                     </div> */}

// // // // // //                                     {/* Price - Column 3 */}
// // // // // //                                     <div style={{
// // // // // //                                         // width: '55px',
// // // // // //                                         textAlign: 'right',
// // // // // //                                         whiteSpace: 'nowrap'
// // // // // //                                     }}>
// // // // // //                                         {item.price > item.effectivePrice ? (
// // // // // //                                             <span>
// // // // // //                                                 <span style={{
// // // // // //                                                     color: '#8b0000',
// // // // // //                                                     textDecoration: 'line-through',
// // // // // //                                                     fontSize: '1rem',
// // // // // //                                                     marginRight: '4px',
// // // // // //                                                     fontWeight: "600"
// // // // // //                                                 }}>
// // // // // //                                                     ₹{item.price}
// // // // // //                                                 </span>
// // // // // //                                                 <span style={{ fontWeight: 'bold' }}>
// // // // // //                                                     ₹{item.effectivePrice}
// // // // // //                                                 </span>
// // // // // //                                             </span>
// // // // // //                                         ) : (
// // // // // //                                             <span style={{ fontWeight: 'bold' }}>
// // // // // //                                                 ₹{item.price}
// // // // // //                                             </span>
// // // // // //                                         )}
// // // // // //                                     </div>
// // // // // //                                 </div>
// // // // // //                             ))}
// // // // // //                         </div>
// // // // // //                     ))}
// // // // // //                 </div>

// // // // // //             </div>
// // // // // //         </div>
// // // // // //     );
// // // // // // };

// // // // // // export default MenuAdvertisement;



// // // // // // import React, { useEffect, useState, useRef } from 'react';
// // // // // // import { useNavigate } from 'react-router-dom';
// // // // // // import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// // // // // // import axios from 'axios';

// // // // // // const MenuAdvertisement = () => {
// // // // // //     const navigate = useNavigate();
// // // // // //     const [menuData, setMenuData] = useState({});
// // // // // //     const [loading, setLoading] = useState(true);
// // // // // //     const scrollContainerRef = useRef(null);

// // // // // //     // ---------------- FETCH MENU ----------------
// // // // // //     useEffect(() => {
// // // // // //         const fetchMenuData = async () => {
// // // // // //             const vendorId = localStorage.getItem("vendorId");
// // // // // //             const token = localStorage.getItem("authToken");

// // // // // //             if (!vendorId || !token) {
// // // // // //                 setLoading(false);
// // // // // //                 return;
// // // // // //             }

// // // // // //             try {
// // // // // //                 const response = await axios.get(
// // // // // //                     `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
// // // // // //                     {
// // // // // //                         headers: {
// // // // // //                             Authorization: `Bearer ${token}`,
// // // // // //                             'Content-Type': 'application/json'
// // // // // //                         }
// // // // // //                     }
// // // // // //                 );

// // // // // //                 const allItems = response.data;

// // // // // //                 const categories = allItems.filter(i => i.parentId === 0);
// // // // // //                 const dishes = allItems.filter(i =>
// // // // // //                     i.parentId !== 0 &&
// // // // // //                     i.menuStatus === "Enable" &&
// // // // // //                     i.stockQuantity > 0
// // // // // //                 );

// // // // // //                 const grouped = {};
// // // // // //                 categories.forEach(cat => {
// // // // // //                     const items = dishes.filter(d => d.parentId === cat.dishId);
// // // // // //                     if (items.length) grouped[cat.dishName] = items;
// // // // // //                 });

// // // // // //                 setMenuData(grouped);
// // // // // //                 setLoading(false);
// // // // // //             } catch (e) {
// // // // // //                 console.error(e);
// // // // // //                 setLoading(false);
// // // // // //             }
// // // // // //         };

// // // // // //         fetchMenuData();
// // // // // //     }, []);

// // // // // //     // ---------------- AUTO SCROLL (FINAL FIX) ----------------
// // // // // //     useEffect(() => {
// // // // // //         const el = scrollContainerRef.current;
// // // // // //         if (!el || Object.keys(menuData).length === 0) return;

// // // // // //         const speed = 1; // 🔥 increase to 2 or 3 if you want faster

// // // // // //         const interval = setInterval(() => {
// // // // // //             const maxScroll = el.scrollHeight - el.clientHeight;

// // // // // //             if (el.scrollTop >= maxScroll - 1) {
// // // // // //                 // 👇 bottom reached → jump to TOP instantly
// // // // // //                 el.scrollTop = 0;
// // // // // //             } else {
// // // // // //                 el.scrollTop += speed;
// // // // // //             }
// // // // // //         }, 20); // lower = faster

// // // // // //         return () => clearInterval(interval);
// // // // // //     }, [menuData]);

// // // // // //     const handleBack = () => navigate('/fooddashboard');

// // // // // //     if (loading) {
// // // // // //         return (
// // // // // //             <div style={{
// // // // // //                 display: 'flex',
// // // // // //                 justifyContent: 'center',
// // // // // //                 alignItems: 'center',
// // // // // //                 height: '100vh'
// // // // // //             }}>
// // // // // //                 <p>Loading menu...</p>
// // // // // //             </div>
// // // // // //         );
// // // // // //     }

// // // // // //     // ---------------- UI ----------------
// // // // // //     return (
// // // // // //         <div style={{
// // // // // //             minHeight: '100vh',
// // // // // //             background: '#f3eadf',
// // // // // //             padding: '20px'
// // // // // //         }}>
// // // // // //             {/* BACK BUTTON */}
// // // // // //             <button
// // // // // //                 onClick={handleBack}
// // // // // //                 style={{
// // // // // //                     position: 'fixed',
// // // // // //                     top: 15,
// // // // // //                     left: 15,
// // // // // //                     background: '#8b0000',
// // // // // //                     color: '#fff',
// // // // // //                     border: 'none',
// // // // // //                     borderRadius: '50%',
// // // // // //                     width: 38,
// // // // // //                     height: 38,
// // // // // //                     zIndex: 1000,
// // // // // //                     display: 'flex',
// // // // // //                     alignItems: 'center',
// // // // // //                     justifyContent: 'center'
// // // // // //                 }}
// // // // // //             >
// // // // // //                 <ArrowBackIcon />
// // // // // //             </button>

// // // // // //             {/* SCROLL CONTAINER */}
// // // // // //             <div
// // // // // //                 ref={scrollContainerRef}
// // // // // //                 style={{
// // // // // //                     background: '#fffaf2',
// // // // // //                     padding: '30px',
// // // // // //                     height: '100vh',          // 🔥 IMPORTANT
// // // // // //                     overflowY: 'auto',
// // // // // //                     overflowX: 'hidden',
// // // // // //                     scrollbarWidth: 'none'
// // // // // //                 }}
// // // // // //             >
// // // // // //                 {/* COLUMNS */}
// // // // // //                 <div style={{
// // // // // //                     columnCount: window.innerWidth < 768 ? 1 : 3,
// // // // // //                     columnGap: '60px'
// // // // // //                 }}>
// // // // // //                     {Object.entries(menuData).map(([category, items]) => (
// // // // // //                         <div
// // // // // //                             key={category}
// // // // // //                             style={{
// // // // // //                                 breakInside: 'avoid',
// // // // // //                                 marginBottom: 30
// // // // // //                             }}
// // // // // //                         >
// // // // // //                             {/* CATEGORY */}
// // // // // //                             <div style={{
// // // // // //                                 fontWeight: 'bold',
// // // // // //                                 fontSize: '1.5rem',
// // // // // //                                 borderBottom: '1px solid #000',
// // // // // //                                 marginBottom: 10
// // // // // //                             }}>
// // // // // //                                 {category}
// // // // // //                             </div>

// // // // // //                             {/* ITEMS */}
// // // // // //                             {items.map(item => (
// // // // // //                                 <div
// // // // // //                                     key={item.dishId}
// // // // // //                                     style={{
// // // // // //                                         display: 'flex',
// // // // // //                                         justifyContent: 'space-between',
// // // // // //                                         marginBottom: 8,
// // // // // //                                         fontSize: '1.2rem'
// // // // // //                                     }}
// // // // // //                                 >
// // // // // //                                     <div style={{ display: 'flex', gap: 6 }}>
// // // // // //                                         {item.tag === "Veg" && (
// // // // // //                                             <span style={{
// // // // // //                                                 width: 14,
// // // // // //                                                 height: 14,
// // // // // //                                                 border: '2px solid green',
// // // // // //                                                 borderRadius: 3,
// // // // // //                                                 position: 'relative'
// // // // // //                                             }}>
// // // // // //                                                 <span style={{
// // // // // //                                                     width: 6,
// // // // // //                                                     height: 6,
// // // // // //                                                     background: 'green',
// // // // // //                                                     borderRadius: '50%',
// // // // // //                                                     position: 'absolute',
// // // // // //                                                     top: 2,
// // // // // //                                                     left: 2
// // // // // //                                                 }} />
// // // // // //                                             </span>
// // // // // //                                         )}
// // // // // //                                         {item.tag === "Non_Veg" && (
// // // // // //                                             <span style={{
// // // // // //                                                 width: 14,
// // // // // //                                                 height: 14,
// // // // // //                                                 border: '2px solid red',
// // // // // //                                                 borderRadius: 3,
// // // // // //                                                 position: 'relative'
// // // // // //                                             }}>
// // // // // //                                                 <span style={{
// // // // // //                                                     width: 6,
// // // // // //                                                     height: 6,
// // // // // //                                                     background: 'red',
// // // // // //                                                     borderRadius: '50%',
// // // // // //                                                     position: 'absolute',
// // // // // //                                                     top: 2,
// // // // // //                                                     left: 2
// // // // // //                                                 }} />
// // // // // //                                             </span>
// // // // // //                                         )}
// // // // // //                                         {item.dishName}
// // // // // //                                     </div>

// // // // // //                                     <div style={{ fontWeight: 'bold' }}>
// // // // // //                                         ₹{item.effectivePrice ?? item.price}
// // // // // //                                     </div>
// // // // // //                                 </div>
// // // // // //                             ))}
// // // // // //                         </div>
// // // // // //                     ))}
// // // // // //                 </div>
// // // // // //             </div>
// // // // // //         </div>
// // // // // //     );
// // // // // // };

// // // // // // export default MenuAdvertisement;




// // // // // import React, { useEffect, useState, useRef, useCallback } from 'react';
// // // // // import { useNavigate } from 'react-router-dom';
// // // // // import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// // // // // import PlayArrowIcon from '@mui/icons-material/PlayArrow';
// // // // // import PauseIcon from '@mui/icons-material/Pause';
// // // // // import axios from 'axios';

// // // // // const MenuAdvertisement = () => {
// // // // //     const navigate = useNavigate();
// // // // //     const [menuData, setMenuData] = useState({});
// // // // //     const [loading, setLoading] = useState(true);
// // // // //     const [isScrolling, setIsScrolling] = useState(true); // Scroll state
// // // // //     const [windowWidth, setWindowWidth] = useState(window.innerWidth);

// // // // //     const scrollContainerRef = useRef(null);
// // // // //     const intervalRef = useRef(null);
// // // // //     const isUserInteractingRef = useRef(false);

// // // // //     // Handle window resize for responsive columns
// // // // //     useEffect(() => {
// // // // //         const handleResize = () => setWindowWidth(window.innerWidth);
// // // // //         window.addEventListener('resize', handleResize);
// // // // //         return () => window.removeEventListener('resize', handleResize);
// // // // //     }, []);

// // // // //     // ---------------- FETCH MENU ----------------
// // // // //     useEffect(() => {
// // // // //         const fetchMenuData = async () => {
// // // // //             const vendorId = localStorage.getItem("vendorId");
// // // // //             const token = localStorage.getItem("authToken");

// // // // //             if (!vendorId || !token) {
// // // // //                 setLoading(false);
// // // // //                 return;
// // // // //             }

// // // // //             try {
// // // // //                 const response = await axios.get(
// // // // //                     `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
// // // // //                     {
// // // // //                         headers: {
// // // // //                             Authorization: `Bearer ${token}`,
// // // // //                             'Content-Type': 'application/json'
// // // // //                         }
// // // // //                     }
// // // // //                 );

// // // // //                 const allItems = response.data;

// // // // //                 const categories = allItems.filter(i => i.parentId === 0);
// // // // //                 const dishes = allItems.filter(i =>
// // // // //                     i.parentId !== 0 &&
// // // // //                     i.menuStatus === "Enable" &&
// // // // //                     i.stockQuantity > 0
// // // // //                 );

// // // // //                 const grouped = {};
// // // // //                 categories.forEach(cat => {
// // // // //                     const items = dishes.filter(d => d.parentId === cat.dishId);
// // // // //                     if (items.length) grouped[cat.dishName] = items;
// // // // //                 });

// // // // //                 setMenuData(grouped);
// // // // //                 setLoading(false);
// // // // //             } catch (e) {
// // // // //                 console.error(e);
// // // // //                 setLoading(false);
// // // // //             }
// // // // //         };

// // // // //         fetchMenuData();
// // // // //     }, []);

// // // // //     // ---------------- AUTO SCROLL WITH PAUSE/RESUME ----------------
// // // // //     const startScrolling = useCallback(() => {
// // // // //         if (intervalRef.current) return;

// // // // //         intervalRef.current = setInterval(() => {
// // // // //             const el = scrollContainerRef.current;
// // // // //             if (!el || !isScrolling || isUserInteractingRef.current) return;

// // // // //             const maxScroll = el.scrollHeight - el.clientHeight;

// // // // //             if (el.scrollTop >= maxScroll - 1) {
// // // // //                 el.scrollTop = 0; // Jump to top smoothly
// // // // //             } else {
// // // // //                 el.scrollTop += 1; // Speed
// // // // //             }
// // // // //         }, 20);
// // // // //     }, [isScrolling]);

// // // // //     const stopScrolling = useCallback(() => {
// // // // //         if (intervalRef.current) {
// // // // //             clearInterval(intervalRef.current);
// // // // //             intervalRef.current = null;
// // // // //         }
// // // // //     }, []);

// // // // //     // Start/stop based on isScrolling state
// // // // //     useEffect(() => {
// // // // //         if (isScrolling) {
// // // // //             startScrolling();
// // // // //         } else {
// // // // //             stopScrolling();
// // // // //         }

// // // // //         return () => stopScrolling();
// // // // //     }, [isScrolling, startScrolling, stopScrolling]);

// // // // //     // Handle user interaction
// // // // //     const handleUserInteraction = useCallback(() => {
// // // // //         isUserInteractingRef.current = true;

// // // // //         // Reset after user stops interacting (optional)
// // // // //         const timeout = setTimeout(() => {
// // // // //             isUserInteractingRef.current = false;
// // // // //         }, 1000);

// // // // //         return () => clearTimeout(timeout);
// // // // //     }, []);

// // // // //     // Mouse events for user interaction
// // // // //     useEffect(() => {
// // // // //         const el = scrollContainerRef.current;
// // // // //         if (!el) return;

// // // // //         const handleMouseEnter = () => {
// // // // //             handleUserInteraction();
// // // // //             if (isScrolling) {
// // // // //                 // Optionally pause on hover? Or just track interaction
// // // // //                 // For now, just track that user is interacting
// // // // //             }
// // // // //         };

// // // // //         const handleMouseLeave = () => {
// // // // //             isUserInteractingRef.current = false;
// // // // //         };

// // // // //         const handleWheel = () => {
// // // // //             handleUserInteraction();
// // // // //         };

// // // // //         const handleTouchStart = () => {
// // // // //             handleUserInteraction();
// // // // //         };

// // // // //         el.addEventListener('mouseenter', handleMouseEnter);
// // // // //         el.addEventListener('mouseleave', handleMouseLeave);
// // // // //         el.addEventListener('wheel', handleWheel);
// // // // //         el.addEventListener('touchstart', handleTouchStart);

// // // // //         return () => {
// // // // //             el.removeEventListener('mouseenter', handleMouseEnter);
// // // // //             el.removeEventListener('mouseleave', handleMouseLeave);
// // // // //             el.removeEventListener('wheel', handleWheel);
// // // // //             el.removeEventListener('touchstart', handleTouchStart);
// // // // //         };
// // // // //     }, [handleUserInteraction]);

// // // // //     const toggleScroll = () => {
// // // // //         setIsScrolling(prev => !prev);
// // // // //     };

// // // // //     const handleBack = () => navigate('/fooddashboard');

// // // // //     // Get column count based on screen size
// // // // //     const getColumnCount = () => {
// // // // //         if (windowWidth < 768) return 1;
// // // // //         if (windowWidth < 1200) return 2;
// // // // //         return 3;
// // // // //     };

// // // // //     if (loading) {
// // // // //         return (
// // // // //             <div style={{
// // // // //                 display: 'flex',
// // // // //                 justifyContent: 'center',
// // // // //                 alignItems: 'center',
// // // // //                 height: '100vh',
// // // // //                 background: '#f3eadf'
// // // // //             }}>
// // // // //                 <div style={{
// // // // //                     textAlign: 'center',
// // // // //                     fontSize: '1.5rem',
// // // // //                     color: '#8b0000'
// // // // //                 }}>
// // // // //                     Loading delicious menu...
// // // // //                 </div>
// // // // //             </div>
// // // // //         );
// // // // //     }

// // // // //     // ---------------- UI ----------------
// // // // //     return (
// // // // //         <div style={{
// // // // //             minHeight: '100vh',
// // // // //             background: '#f3eadf',
// // // // //             padding: window.innerWidth < 2000 ? "2%" : '3%',
// // // // //             position: 'relative'
// // // // //         }}>
// // // // //             {/* BACK BUTTON */}
// // // // //             <button
// // // // //                 onClick={handleBack}
// // // // //                 style={{
// // // // //                     position: 'fixed',
// // // // //                     top: 15,
// // // // //                     left: 15,
// // // // //                     background: '#8b0000',
// // // // //                     color: '#fff',
// // // // //                     border: 'none',
// // // // //                     borderRadius: '50%',
// // // // //                     width: window.innerWidth< 2000 ?  45 : "7rem",
// // // // //                     height: window.innerWidth< 2000 ?  45 : "7rem",
// // // // //                     zIndex: 1000,
// // // // //                     display: 'flex',
// // // // //                     alignItems: 'center',
// // // // //                     justifyContent: 'center',
// // // // //                     cursor: 'pointer',
// // // // //                     boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
// // // // //                     transition: 'transform 0.2s',
// // // // //                     ':hover': {
// // // // //                         transform: 'scale(1.1)'
// // // // //                     }
// // // // //                 }}
// // // // //             >
// // // // //                 <ArrowBackIcon style={{ fontSize:  window.innerWidth < 2000 ? 24 : "5rem" }} />
// // // // //             </button>

// // // // //             {/* PLAY/PAUSE BUTTON - PREMIUM FEATURE */}
// // // // //             <button
// // // // //                 onClick={toggleScroll}
// // // // //                 style={{
// // // // //                     position: 'fixed',
// // // // //                     top: 15,
// // // // //                     right: 15,
// // // // //                     background: isScrolling ? '#8b0000' : '#2e7d32',
// // // // //                     color: '#fff',
// // // // //                     border: 'none',
// // // // //                     borderRadius: '50%',
// // // // //                     width: window.innerWidth< 2000 ?  45 : "7rem",
// // // // //                     height: window.innerWidth< 2000 ?  45 : "7rem",
// // // // //                     zIndex: 1000,
// // // // //                     display: 'flex',
// // // // //                     alignItems: 'center',
// // // // //                     justifyContent: 'center',
// // // // //                     cursor: 'pointer',
// // // // //                     boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
// // // // //                     transition: 'all 0.3s ease'
// // // // //                 }}
// // // // //             >
// // // // //                 {isScrolling ? <PauseIcon style={{ fontSize:  window.innerWidth < 2000 ? 24 : "5rem" }} /> : <PlayArrowIcon style={{ fontSize:  window.innerWidth < 2000 ? 24 : "5rem" }} />}
// // // // //             </button>

// // // // //             {/* SCROLL CONTAINER */}
// // // // //             <div
// // // // //                 ref={scrollContainerRef}
// // // // //                 style={{
// // // // //                     background: '#fffaf2',
// // // // //                     padding: '40px',
// // // // //                     // height: window.innerWidth < 2000 ? 'calc(100vh - 5rem)' : 'calc(100vh - 40px)',
// // // // //                     height:"90vh",
// // // // //                     overflowY: 'auto',
// // // // //                     overflowX: 'hidden',
// // // // //                     scrollbarWidth: 'none',
// // // // //                     msOverflowStyle: 'none',
// // // // //                     borderRadius: '20px',
// // // // //                     boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
// // // // //                     position: 'relative'
// // // // //                 }}
// // // // //             >
// // // // //                 {/* AUTO SCROLL INDICATOR */}
// // // // //                 {/* <div style={{
// // // // //                     position: 'sticky',
// // // // //                     top: 0,
// // // // //                     right: 0,
// // // // //                     textAlign: 'right',
// // // // //                     padding: '10px',
// // // // //                     fontSize: '0.9rem',
// // // // //                     color: isScrolling ? '#8b0000' : '#2e7d32',
// // // // //                     fontWeight: 'bold',
// // // // //                     backgroundColor: 'rgba(255,250,242,0.9)',
// // // // //                     zIndex: 10,
// // // // //                     borderRadius: '0 0 0 10px',
// // // // //                     display: 'inline-block',
// // // // //                     float: 'right'
// // // // //                 }}>
// // // // //                     {isScrolling ? '🔴 Auto-scrolling' : '⚫ Paused'}
// // // // //                 </div> */}

// // // // //                 {/* COLUMNS */}
// // // // //                 <div style={{
// // // // //                     columnCount: getColumnCount(),
// // // // //                     columnGap: '60px',
// // // // //                     clear: 'both'
// // // // //                 }}>
// // // // //                     {Object.entries(menuData).map(([category, items]) => (
// // // // //                         <div
// // // // //                             key={category}
// // // // //                             style={{
// // // // //                                 breakInside: 'avoid',
// // // // //                                 marginBottom: 30,
// // // // //                                 pageBreakInside: 'avoid'
// // // // //                             }}
// // // // //                         >
// // // // //                             {/* CATEGORY HEADER */}
// // // // //                             <div style={{
// // // // //                                 fontWeight: 'bold',
// // // // //                                 fontSize: 'clamp(1.5rem, 1.8vw, 4rem)',
// // // // //                                 borderBottom: '3px solid #8b0000',
// // // // //                                 marginBottom: 15,
// // // // //                                 paddingBottom: 5,
// // // // //                                 color: '#8b0000',
// // // // //                                 fontFamily: 'Georgia, serif'
// // // // //                             }}>
// // // // //                                 {category}
// // // // //                             </div>

// // // // //                             {/* ITEMS */}
// // // // //                             {items.map((item, index) => (
// // // // //                                 <div
// // // // //                                     key={item.dishId}
// // // // //                                     style={{
// // // // //                                         display: 'flex',
// // // // //                                         justifyContent: 'space-between',
// // // // //                                         marginBottom: 12,
// // // // //                                         fontSize: 'clamp(1rem, 1.4vw, 3.5rem)',
// // // // //                                         padding: '5px 0',
// // // // //                                         borderBottom: index === items.length - 1 ? 'none' : '1px dashed #ddd',
// // // // //                                         transition: 'background 0.2s',
// // // // //                                         ':hover': {
// // // // //                                             background: '#f9f9f9'
// // // // //                                         }
// // // // //                                     }}
// // // // //                                 >
// // // // //                                     <div style={{
// // // // //                                         display: 'flex',
// // // // //                                         gap: 10,
// // // // //                                         alignItems: 'center',
// // // // //                                         flex: 1
// // // // //                                     }}>
// // // // //                                         {/* Veg/Non-veg indicator */}
// // // // //                                         {item.tag === "Veg" && (
// // // // //                                             <span style={{
// // // // //                                                 width: 18,
// // // // //                                                 height: 18,
// // // // //                                                 border: '2px solid #4caf50',
// // // // //                                                 borderRadius: 4,
// // // // //                                                 position: 'relative',
// // // // //                                                 display: 'inline-block',
// // // // //                                                 background: '#fff'
// // // // //                                             }}>
// // // // //                                                 <span style={{
// // // // //                                                     width: 8,
// // // // //                                                     height: 8,
// // // // //                                                     background: '#4caf50',
// // // // //                                                     borderRadius: '50%',
// // // // //                                                     position: 'absolute',
// // // // //                                                     top: 3,
// // // // //                                                     left: 3
// // // // //                                                 }} />
// // // // //                                             </span>
// // // // //                                         )}
// // // // //                                         {item.tag === "Non_Veg" && (
// // // // //                                             <span style={{
// // // // //                                                 width: 18,
// // // // //                                                 height: 18,
// // // // //                                                 border: '2px solid #f44336',
// // // // //                                                 borderRadius: 4,
// // // // //                                                 position: 'relative',
// // // // //                                                 display: 'inline-block',
// // // // //                                                 background: '#fff'
// // // // //                                             }}>
// // // // //                                                 <span style={{
// // // // //                                                     width: 8,
// // // // //                                                     height: 8,
// // // // //                                                     background: '#f44336',
// // // // //                                                     borderRadius: '50%',
// // // // //                                                     position: 'absolute',
// // // // //                                                     top: 3,
// // // // //                                                     left: 3
// // // // //                                                 }} />
// // // // //                                             </span>
// // // // //                                         )}
// // // // //                                         <span style={{
// // // // //                                             fontFamily: 'Arial, sans-serif'
// // // // //                                         }}>
// // // // //                                             {item.dishName}
// // // // //                                         </span>

// // // // //                                     </div>

// // // // //                                     <div style={{
// // // // //                                         display: 'flex',
// // // // //                                         alignItems: 'center',
// // // // //                                         gap: '8px',
// // // // //                                         marginLeft: 20
// // // // //                                     }}>
// // // // //                                         {item.price > item.effectivePrice ? (
// // // // //                                             <>
// // // // //                                                 <span style={{
// // // // //                                                     color: '#666',
// // // // //                                                     textDecoration: 'line-through',
// // // // //                                                     fontSize: 'clamp(0.9rem, 1.1vw, 2.8rem)',
// // // // //                                                     fontWeight: 'normal'
// // // // //                                                 }}>
// // // // //                                                     ₹{item.price}
// // // // //                                                 </span>
// // // // //                                                 <span style={{
// // // // //                                                     fontWeight: '500',
// // // // //                                                     color: '#212529',
// // // // //                                                     fontSize: 'clamp(1rem, 1.3vw, 3.5rem)'
// // // // //                                                 }}>
// // // // //                                                     ₹{item.effectivePrice}
// // // // //                                                 </span>
// // // // //                                             </>
// // // // //                                         ) : (
// // // // //                                             <span style={{
// // // // //                                                 fontWeight: '500',
// // // // //                                                 color: '#212529',
// // // // //                                                 fontSize: 'clamp(1rem, 1.3vw, 3.5rem)'
// // // // //                                             }}>
// // // // //                                                 ₹{item.price}
// // // // //                                             </span>
// // // // //                                         )}
// // // // //                                     </div>
// // // // //                                 </div>
// // // // //                             ))}
// // // // //                         </div>
// // // // //                     ))}
// // // // //                 </div>
// // // // //             </div>
// // // // //         </div>
// // // // //     );
// // // // // };

// // // // // export default MenuAdvertisement;


// // // // import React, { useEffect, useState, useRef, useCallback } from 'react';
// // // // import { useNavigate } from 'react-router-dom';
// // // // import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// // // // import PlayArrowIcon from '@mui/icons-material/PlayArrow';
// // // // import PauseIcon from '@mui/icons-material/Pause';
// // // // import axios from 'axios';

// // // // const MenuAdvertisement = () => {
// // // //     const navigate = useNavigate();
// // // //     const [menuData, setMenuData] = useState({});
// // // //     const [loading, setLoading] = useState(true);
// // // //     const [isScrolling, setIsScrolling] = useState(true); // Scroll state
// // // //     const [windowWidth, setWindowWidth] = useState(window.innerWidth);

// // // //     const scrollContainerRef = useRef(null);
// // // //     const intervalRef = useRef(null);
// // // //     const isUserInteractingRef = useRef(false);
// // // //     const hasItems = Object.keys(menuData).length > 0;


// // // //     // Handle window resize for responsive columns
// // // //     useEffect(() => {
// // // //         const handleResize = () => setWindowWidth(window.innerWidth);
// // // //         window.addEventListener('resize', handleResize);
// // // //         return () => window.removeEventListener('resize', handleResize);
// // // //     }, []);

// // // //     // ---------------- FETCH MENU ----------------
// // // //     // useEffect(() => {
// // // //     //     const fetchMenuData = async () => {
// // // //     //         const vendorId = localStorage.getItem("vendorId");
// // // //     //         const token = localStorage.getItem("authToken");

// // // //     //         if (!vendorId || !token) {
// // // //     //             setLoading(false);
// // // //     //             return;
// // // //     //         }

// // // //     //         try {
// // // //     //             const response = await axios.get(
// // // //     //                 `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
// // // //     //                 {
// // // //     //                     headers: {
// // // //     //                         Authorization: `Bearer ${token}`,
// // // //     //                         'Content-Type': 'application/json'
// // // //     //                     }
// // // //     //                 }
// // // //     //             );

// // // //     //             const allItems = response.data;

// // // //     //             const categories = allItems.filter(i => i.parentId === 0);
// // // //     //             const dishes = allItems.filter(i =>
// // // //     //                 i.parentId !== 0 &&
// // // //     //                 i.menuStatus === "Enable" &&
// // // //     //                 i.stockQuantity > 0
// // // //     //             );

// // // //     //             const grouped = {};
// // // //     //             categories.forEach(cat => {
// // // //     //                 const items = dishes.filter(d => d.parentId === cat.dishId);
// // // //     //                 if (items.length) grouped[cat.dishName] = items;
// // // //     //             });

// // // //     //             setMenuData(grouped);
// // // //     //             setLoading(false);
// // // //     //         } catch (e) {
// // // //     //             console.error(e);
// // // //     //             setLoading(false);
// // // //     //         }
// // // //     //     };

// // // //     //     fetchMenuData();
// // // //     // }, []);

// // // //     useEffect(() => {
// // // //         let intervalId;

// // // //         const fetchMenuData = async () => {
// // // //             const vendorId = localStorage.getItem("vendorId");
// // // //             const token = localStorage.getItem("authToken");

// // // //             if (!vendorId || !token) {
// // // //                 setLoading(false);
// // // //                 return;
// // // //             }

// // // //             try {
// // // //                 const response = await axios.get(
// // // //                     `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
// // // //                     {
// // // //                         headers: {
// // // //                             Authorization: `Bearer ${token}`,
// // // //                             'Content-Type': 'application/json'
// // // //                         }
// // // //                     }
// // // //                 );

// // // //                 const allItems = response.data;

// // // //                 const categories = allItems.filter(i => i.parentId === 0);
// // // //                 const dishes = allItems.filter(i =>
// // // //                     i.parentId !== 0 &&
// // // //                     i.menuStatus === "Enable" &&
// // // //                     i.stockQuantity > 0
// // // //                 );

// // // //                 const grouped = {};
// // // //                 categories.forEach(cat => {
// // // //                     const items = dishes.filter(d => d.parentId === cat.dishId);
// // // //                     if (items.length) grouped[cat.dishName] = items;
// // // //                 });

// // // //                 setMenuData(grouped);
// // // //                 setLoading(false);
// // // //             } catch (e) {
// // // //                 console.error(e);
// // // //                 setLoading(false);
// // // //             }
// // // //         };

// // // //         // Call immediately on mount
// // // //         fetchMenuData();

// // // //         // Call every 20 seconds
// // // //         intervalId = setInterval(fetchMenuData, 20000);

// // // //         // Cleanup when component unmounts
// // // //         return () => {
// // // //             clearInterval(intervalId);
// // // //         };
// // // //     }, []);
// // // //     // Add this function inside your component
// // // //     const isContentScrollable = useCallback(() => {
// // // //         if (!scrollContainerRef.current) return false;

// // // //         const container = scrollContainerRef.current;
// // // //         // Check if content height is greater than container height
// // // //         return container.scrollHeight > container.clientHeight;
// // // //     }, [menuData]); // Re-run when menuData changes

// // // //     // Also add a state to force re-check when content loads
// // // //     const [contentHeight, setContentHeight] = useState(0);

// // // //     // Use effect to check scrollability after content renders
// // // //     useEffect(() => {
// // // //         if (hasItems && scrollContainerRef.current) {
// // // //             // Small delay to ensure DOM is fully rendered
// // // //             const timer = setTimeout(() => {
// // // //                 setContentHeight(scrollContainerRef.current?.scrollHeight || 0);
// // // //             }, 100);

// // // //             return () => clearTimeout(timer);
// // // //         }
// // // //     }, [menuData, hasItems]);

// // // //     // ---------------- AUTO SCROLL WITH PAUSE/RESUME ----------------
// // // //     const startScrolling = useCallback(() => {
// // // //         if (intervalRef.current) return;

// // // //         intervalRef.current = setInterval(() => {
// // // //             const el = scrollContainerRef.current;
// // // //             if (!el || !isScrolling || isUserInteractingRef.current) return;

// // // //             const maxScroll = el.scrollHeight - el.clientHeight;

// // // //             if (el.scrollTop >= maxScroll - 1) {
// // // //                 el.scrollTop = 0; // Jump to top smoothly
// // // //             } else {
// // // //                 el.scrollTop += 1; // Speed
// // // //             }
// // // //         }, 20);
// // // //     }, [isScrolling]);

// // // //     const stopScrolling = useCallback(() => {
// // // //         if (intervalRef.current) {
// // // //             clearInterval(intervalRef.current);
// // // //             intervalRef.current = null;
// // // //         }
// // // //     }, []);

// // // //     // Start/stop based on isScrolling state
// // // //     useEffect(() => {
// // // //         if (isScrolling) {
// // // //             startScrolling();
// // // //         } else {
// // // //             stopScrolling();
// // // //         }

// // // //         return () => stopScrolling();
// // // //     }, [isScrolling, startScrolling, stopScrolling]);

// // // //     // Handle user interaction
// // // //     const handleUserInteraction = useCallback(() => {
// // // //         isUserInteractingRef.current = true;

// // // //         // Reset after user stops interacting (optional)
// // // //         const timeout = setTimeout(() => {
// // // //             isUserInteractingRef.current = false;
// // // //         }, 1000);

// // // //         return () => clearTimeout(timeout);
// // // //     }, []);

// // // //     // Mouse events for user interaction
// // // //     useEffect(() => {
// // // //         const el = scrollContainerRef.current;
// // // //         if (!el) return;

// // // //         const handleMouseEnter = () => {
// // // //             handleUserInteraction();
// // // //             if (isScrolling) {
// // // //                 // Optionally pause on hover? Or just track interaction
// // // //                 // For now, just track that user is interacting
// // // //             }
// // // //         };

// // // //         const handleMouseLeave = () => {
// // // //             isUserInteractingRef.current = false;
// // // //         };

// // // //         const handleWheel = () => {
// // // //             handleUserInteraction();
// // // //         };

// // // //         const handleTouchStart = () => {
// // // //             handleUserInteraction();
// // // //         };

// // // //         el.addEventListener('mouseenter', handleMouseEnter);
// // // //         el.addEventListener('mouseleave', handleMouseLeave);
// // // //         el.addEventListener('wheel', handleWheel);
// // // //         el.addEventListener('touchstart', handleTouchStart);

// // // //         return () => {
// // // //             el.removeEventListener('mouseenter', handleMouseEnter);
// // // //             el.removeEventListener('mouseleave', handleMouseLeave);
// // // //             el.removeEventListener('wheel', handleWheel);
// // // //             el.removeEventListener('touchstart', handleTouchStart);
// // // //         };
// // // //     }, [handleUserInteraction]);

// // // //     const toggleScroll = () => {
// // // //         setIsScrolling(prev => !prev);
// // // //     };

// // // //     const handleBack = () => navigate('/fooddashboard');

// // // //     // Get column count based on screen size
// // // //     const getColumnCount = () => {
// // // //         if (windowWidth < 768) return 1;
// // // //         if (windowWidth < 1200) return 2;
// // // //         return 3;
// // // //     };

// // // //     // Check if menu has any items

// // // //     if (loading) {
// // // //         return (
// // // //             <div style={{
// // // //                 display: 'flex',
// // // //                 justifyContent: 'center',
// // // //                 alignItems: 'center',
// // // //                 height: '100vh',
// // // //                 background: '#f3eadf'
// // // //             }}>
// // // //                 <div style={{
// // // //                     textAlign: 'center',
// // // //                     fontSize: '1.5rem',
// // // //                     color: '#8b0000'
// // // //                 }}>
// // // //                     Loading delicious menu...
// // // //                 </div>
// // // //             </div>
// // // //         );
// // // //     }

// // // //     // ---------------- UI ----------------
// // // //     return (
// // // //         <div style={{
// // // //             minHeight: '100vh',
// // // //             padding: window.innerWidth < 2000 ? "2%" : '3%',
// // // //             position: 'relative',
// // // //             textTransform: 'uppercase'
// // // //         }}>
// // // //             {/* BACK BUTTON */}
// // // //             <button
// // // //                 onClick={handleBack}
// // // //                 style={{
// // // //                     position: 'fixed',
// // // //                     top: 15,
// // // //                     left: 15,
// // // //                     background: '#8b0000',
// // // //                     color: '#fff',
// // // //                     border: 'none',
// // // //                     borderRadius: '50%',
// // // //                     width: window.innerWidth < 2000 ? 45 : "7rem",
// // // //                     height: window.innerWidth < 2000 ? 45 : "7rem",
// // // //                     zIndex: 1000,
// // // //                     display: 'flex',
// // // //                     alignItems: 'center',
// // // //                     justifyContent: 'center',
// // // //                     cursor: 'pointer',
// // // //                     boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
// // // //                     transition: 'transform 0.2s',
// // // //                     ':hover': {
// // // //                         transform: 'scale(1.1)'
// // // //                     }
// // // //                 }}
// // // //             >
// // // //                 <ArrowBackIcon style={{ fontSize: window.innerWidth < 2000 ? 24 : "5rem" }} />
// // // //             </button>

// // // //             {/* PLAY/PAUSE BUTTON - PREMIUM FEATURE */}
// // // //             {hasItems && (
// // // //                 <button
// // // //                     onClick={toggleScroll}
// // // //                     style={{
// // // //                         position: 'fixed',
// // // //                         top: 15,
// // // //                         right: 15,
// // // //                         background: isScrolling ? '#8b0000' : '#2e7d32',
// // // //                         color: '#fff',
// // // //                         border: 'none',
// // // //                         borderRadius: '50%',
// // // //                         width: window.innerWidth < 2000 ? 45 : "7rem",
// // // //                         height: window.innerWidth < 2000 ? 45 : "7rem",
// // // //                         zIndex: 1000,
// // // //                         display: 'flex',
// // // //                         alignItems: 'center',
// // // //                         justifyContent: 'center',
// // // //                         cursor: 'pointer',
// // // //                         boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
// // // //                         transition: 'all 0.3s ease'
// // // //                     }}
// // // //                 >
// // // //                     {isScrolling ? <PauseIcon style={{ fontSize: window.innerWidth < 2000 ? 24 : "5rem" }} /> : <PlayArrowIcon style={{ fontSize: window.innerWidth < 2000 ? 24 : "5rem" }} />}
// // // //                 </button>
// // // //             )}

// // // //             {/* SCROLL CONTAINER */}
// // // //             <div
// // // //                 ref={scrollContainerRef}
// // // //                 style={{
// // // //                     background: '#ee4b2e',
// // // //                     padding: '40px',
// // // //                     height: "90vh",
// // // //                     overflowY: 'auto',
// // // //                     overflowX: 'hidden',
// // // //                     scrollbarWidth: 'none',
// // // //                     msOverflowStyle: 'none',
// // // //                     borderRadius: '20px',
// // // //                     boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
// // // //                     position: 'relative',
// // // //                     display: !hasItems ? "flex" : " ",
// // // //                     alignItems: hasItems ? 'flex-start' : 'center',
// // // //                     justifyContent: hasItems ? 'flex-start' : 'center'
// // // //                 }}
// // // //             >
// // // //                 {/* Conditionally show top padding ONLY if content is tall enough */}
// // // //                 {hasItems && Object.keys(menuData).length > 0 && isContentScrollable() && (
// // // //                     <div style={{ height: "50vh" }} />
// // // //                 )}

// // // //                 {!hasItems ? (
// // // //                     /* NO ITEMS MESSAGE */
// // // //                     <div style={{
// // // //                         textAlign: 'center',
// // // //                         maxWidth: '600px',
// // // //                         padding: '40px 20px'
// // // //                     }}>
// // // //                         {/* Empty Plate Icon */}
// // // //                         <div style={{
// // // //                             fontSize: '6rem',
// // // //                             marginBottom: '20px',
// // // //                             opacity: 0.5
// // // //                         }}>
// // // //                             🍽️
// // // //                         </div>

// // // //                         {/* Main Message */}
// // // //                         <h2 style={{
// // // //                             fontSize: 'clamp(2rem, 4vw, 3rem)',
// // // //                             color: '#8b0000',
// // // //                             marginBottom: '20px',
// // // //                             fontFamily: 'Georgia, serif'
// // // //                         }}>
// // // //                             Menu is Empty
// // // //                         </h2>

// // // //                         {/* Description */}
// // // //                         <p style={{
// // // //                             fontSize: 'clamp(1.2rem, 2vw, 1.5rem)',
// // // //                             color: '#666',
// // // //                             lineHeight: 1.6,
// // // //                             marginBottom: '30px'
// // // //                         }}>
// // // //                             No items available in the menu at the moment.
// // // //                             <br />
// // // //                             Please check back later
// // // //                         </p>
// // // //                     </div>
// // // //                 ) : (
// // // //                     /* COLUMNS - Only show if items exist */
// // // //                     <div style={{
// // // //                         columnCount: getColumnCount(),
// // // //                         columnGap: '60px',
// // // //                         clear: 'both',
// // // //                         width: '100%'
// // // //                     }}>
// // // //                         {Object.entries(menuData).map(([category, items]) => (
// // // //                             <div
// // // //                                 key={category}
// // // //                                 style={{
// // // //                                     breakInside: 'avoid',
// // // //                                     marginBottom: 30,
// // // //                                     pageBreakInside: 'avoid'
// // // //                                 }}
// // // //                             >
// // // //                                 {/* CATEGORY HEADER */}
// // // //                                 <div style={{
// // // //                                     fontWeight: 'bold',
// // // //                                     fontSize: 'clamp(1.5rem, 3rem, 4rem)',
// // // //                                     marginBottom: 15,
// // // //                                     paddingBottom: 5,
// // // //                                     color: '#ffffff',
// // // //                                     fontFamily: 'Georgia, serif',
// // // //                                     display: "flex",
// // // //                                     alignItems: "center",
// // // //                                     justifyContent: "center",
// // // //                                 }}>
// // // //                                     {category}
// // // //                                 </div>

// // // //                                 {/* ITEMS */}
// // // //                                 {items.map((item, index) => (
// // // //                                     <div
// // // //                                         key={item.dishId}
// // // //                                         style={{
// // // //                                             display: 'flex',
// // // //                                             justifyContent: 'space-between',
// // // //                                             color: "#fff",
// // // //                                             marginBottom: 12,

// // // //                                             fontSize: 'clamp(1rem, 1.8vw, 3.5rem)',
// // // //                                             padding: '5px 0',
// // // //                                             // borderBottom: index === items.length - 1 ? 'none' : '1px dashed #ddd',
// // // //                                             transition: 'background 0.2s',
// // // //                                             ':hover': {
// // // //                                                 background: '#f9f9f9'
// // // //                                             }
// // // //                                         }}
// // // //                                     >
// // // //                                         <div style={{
// // // //                                             display: 'flex',
// // // //                                             gap: 10,
// // // //                                             alignItems: 'center',
// // // //                                             flex: 1
// // // //                                         }}>
// // // //                                             {/* Veg/Non-veg indicator */}
// // // //                                             {item.tag === "Veg" && (
// // // //                                                 <span style={{
// // // //                                                     width: 18,
// // // //                                                     height: 18,
// // // //                                                     border: '2px solid #4caf50',
// // // //                                                     borderRadius: 4,
// // // //                                                     position: 'relative',
// // // //                                                     display: 'inline-block',
// // // //                                                     background: '#fff'
// // // //                                                 }}>
// // // //                                                     <span style={{
// // // //                                                         width: 8,
// // // //                                                         height: 8,
// // // //                                                         background: '#4caf50',
// // // //                                                         borderRadius: '50%',
// // // //                                                         position: 'absolute',
// // // //                                                         top: 3,
// // // //                                                         left: 3
// // // //                                                     }} />
// // // //                                                 </span>
// // // //                                             )}
// // // //                                             {item.tag === "Non_Veg" && (
// // // //                                                 <span style={{
// // // //                                                     width: 18,
// // // //                                                     height: 18,
// // // //                                                     border: '2px solid #f44336',
// // // //                                                     borderRadius: 4,
// // // //                                                     position: 'relative',
// // // //                                                     display: 'inline-block',
// // // //                                                     background: '#fff'
// // // //                                                 }}>
// // // //                                                     <span style={{
// // // //                                                         width: 8,
// // // //                                                         height: 8,
// // // //                                                         background: '#f44336',
// // // //                                                         borderRadius: '50%',
// // // //                                                         position: 'absolute',
// // // //                                                         top: 3,
// // // //                                                         left: 3
// // // //                                                     }} />
// // // //                                                 </span>
// // // //                                             )}
// // // //                                             <span style={{
// // // //                                                 fontFamily: 'Arial, sans-serif'
// // // //                                             }}>
// // // //                                                 {item.dishName}
// // // //                                             </span>
// // // //                                         </div>

// // // //                                         <div style={{
// // // //                                             display: 'flex',
// // // //                                             alignItems: 'center',
// // // //                                             gap: '8px',
// // // //                                             marginLeft: 20
// // // //                                         }}>
// // // //                                             {/* {item.price > item.effectivePrice ? (
// // // //                                                 <>
// // // //                                                     <span style={{
// // // //                                                         color: '#666',
// // // //                                                         textDecoration: 'line-through',
// // // //                                                         fontSize: 'clamp(0.9rem, 1.1vw, 2.8rem)',
// // // //                                                         fontWeight: 'normal'
// // // //                                                     }}>
// // // //                                                         ₹{item.price}
// // // //                                                     </span>
// // // //                                                     <span style={{
// // // //                                                         fontWeight: '500',
// // // //                                                         color: '#212529',
// // // //                                                         fontSize: 'clamp(1rem, 1.3vw, 3.5rem)'
// // // //                                                     }}>
// // // //                                                         ₹{item.effectivePrice}
// // // //                                                     </span>
// // // //                                                 </>
// // // //                                             ) : (
// // // //                                                 <span style={{
// // // //                                                     fontWeight: '500',
// // // //                                                     color: '#212529',
// // // //                                                     fontSize: 'clamp(1rem, 1.3vw, 3.5rem)'
// // // //                                                 }}>
// // // //                                                     ₹{item.price}
// // // //                                                 </span>
// // // //                                             )} */}

// // // //                                             <span style={{
// // // //                                                 fontWeight: '500',
// // // //                                                 color: "#fff",
// // // //                                                 fontSize: 'clamp(1rem, 1.6vw, 3.5rem)'
// // // //                                             }}>
// // // //                                                 ₹{item.price}
// // // //                                             </span>
// // // //                                         </div>
// // // //                                     </div>
// // // //                                 ))}
// // // //                             </div>
// // // //                         ))}
// // // //                     </div>
// // // //                 )}

// // // //                 {/* Conditionally show bottom padding ONLY if content is tall enough */}
// // // //                 {hasItems && Object.keys(menuData).length > 0 && isContentScrollable() && (
// // // //                     <div style={{ height: "50vh" }} />
// // // //                 )}
// // // //             </div>
// // // //         </div>
// // // //     );
// // // // };

// // // // export default MenuAdvertisement;







// // // import React, { useEffect, useState, useRef } from "react";
// // // import { useNavigate } from "react-router-dom";
// // // import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// // // import axios from "axios";

// // // const MenuAdvertisement = () => {
// // //     const navigate = useNavigate();
// // //       const slideContainerRef = useRef(null);

// // //     const [slides, setSlides] = useState([]);
// // //     const [currentSlide, setCurrentSlide] = useState(0);
// // //     const [loading, setLoading] = useState(true);

// // //     const handleBack = () => navigate("/fooddashboard");
// // // const [isTransitioning, setIsTransitioning] = useState(false);
// // //     // Function to distribute items with exactly 12 items per column
// // //     const distributeItemsToColumns = (items) => {
// // //         const columns = [[], [], []];
// // //         const ITEMS_PER_COLUMN = 17;

// // //         let currentColumn = 0;
// // //         let currentColumnItems = [];

// // //         items.forEach(item => {
// // //             // Add item to current column's temporary list
// // //             currentColumnItems.push(item);

// // //             // If this column has reached 12 items, move to next column
// // //             if (currentColumnItems.length === ITEMS_PER_COLUMN) {
// // //                 columns[currentColumn] = [...currentColumnItems];
// // //                 currentColumnItems = [];
// // //                 currentColumn = (currentColumn + 1) % 3;
// // //             }
// // //         });

// // //         // Add remaining items to the last column
// // //         if (currentColumnItems.length > 0) {
// // //             columns[currentColumn] = [...currentColumnItems];
// // //         }

// // //         // Ensure all columns have arrays (even if empty)
// // //         for (let i = 0; i < 3; i++) {
// // //             if (!columns[i]) {
// // //                 columns[i] = [];
// // //             }
// // //         }

// // //         return columns;
// // //     };

// // //     useEffect(() => {
// // //         const fetchMenuData = async () => {
// // //             const vendorId = localStorage.getItem("vendorId");
// // //             const token = localStorage.getItem("authToken");

// // //             if (!vendorId || !token) {
// // //                 setLoading(false);
// // //                 return;
// // //             }

// // //             try {
// // //                 const response = await axios.get(
// // //                     `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
// // //                     {
// // //                         headers: { Authorization: `Bearer ${token}` },
// // //                     }
// // //                 );

// // //                 const allItems = response.data;

// // //                 const categories = allItems.filter(i => i.parentId === 0);
// // //                 const dishes = allItems.filter(
// // //                     i =>
// // //                         i.parentId !== 0 &&
// // //                         i.menuStatus === "Enable" &&
// // //                         i.stockQuantity > 0
// // //                 );

// // //                 let structuredList = [];

// // //                 categories.forEach(category => {
// // //                     const categoryItems = dishes.filter(
// // //                         d => d.parentId === category.dishId
// // //                     );

// // //                     if (categoryItems.length > 0) {
// // //                         structuredList.push({
// // //                             type: "category",
// // //                             name: category.dishName.toUpperCase()
// // //                         });

// // //                         categoryItems.forEach(item => {
// // //                             structuredList.push({
// // //                                 type: "item",
// // //                                 dishName: item.dishName.toUpperCase(),
// // //                                 price: item.price,
// // //                                 dishId: item.dishId
// // //                             });
// // //                         });
// // //                     }
// // //                 });

// // //                 // Create slides with 36 items each (3 columns × 12 items)
// // //                 const SLIDE_SIZE = 51;
// // //                 const generatedSlides = [];

// // //                 for (let i = 0; i < structuredList.length; i += SLIDE_SIZE) {
// // //                     generatedSlides.push(structuredList.slice(i, i + SLIDE_SIZE));
// // //                 }

// // //                 setSlides(generatedSlides);
// // //                 setLoading(false);

// // //             } catch (error) {
// // //                 console.error(error);
// // //                 setLoading(false);
// // //             }
// // //         };

// // //         fetchMenuData();
// // //     }, []);

// // //     const goToSlide = (index) => {
// // //         if (isTransitioning || index === currentSlide) return;

// // //         setIsTransitioning(true);
// // //         setCurrentSlide(index);

// // //         setTimeout(() => {
// // //             setIsTransitioning(false);
// // //         }, 500); // Match this with CSS transition duration
// // //     };

// // //     const nextSlide = () => {
// // //         if (slides.length <= 1 || isTransitioning) return;
// // //         const nextIndex = currentSlide === slides.length - 1 ? 0 : currentSlide + 1;
// // //         goToSlide(nextIndex);
// // //     };

// // //     const prevSlide = () => {
// // //         if (slides.length <= 1 || isTransitioning) return;
// // //         const prevIndex = currentSlide === 0 ? slides.length - 1 : currentSlide - 1;
// // //         goToSlide(prevIndex);
// // //     };

// // //     // Auto slide with smooth transition
// // //     useEffect(() => {
// // //         if (slides.length <= 1) return;

// // //         const interval = setInterval(() => {
// // //             nextSlide();
// // //         }, 10000);

// // //         return () => clearInterval(interval);
// // //     }, [slides, currentSlide, isTransitioning]);

// // //     if (loading) {
// // //         return (
// // //             <div style={{
// // //                 height: "100vh",
// // //                 display: "flex",
// // //                 justifyContent: "center",
// // //                 alignItems: "center",
// // //                 fontSize: "2rem",
// // //                 // background: "#ee4b2e",
// // //                 backgroundColor:"#212529",
// // //                 color: "#fff",
// // //                 textTransform: "uppercase"
// // //             }}>
// // //                 LOADING MENU...
// // //             </div>
// // //         );
// // //     }

// // //     if (slides.length === 0) {
// // //         return (
// // //             <div style={{
// // //                 height: "100vh",
// // //                 display: "flex",
// // //                 justifyContent: "center",
// // //                 alignItems: "center",
// // //                 fontSize: "2rem",
// // //                 // background: "#ee4b2e",
// // //                 backgroundColor:"black",
// // //                 color: "#fff",
// // //                 textTransform: "uppercase"
// // //             }}>
// // //                 NO MENU AVAILABLE
// // //             </div>
// // //         );
// // //     }

// // //     const currentSlideData = slides[currentSlide];
// // //     const columns = distributeItemsToColumns(currentSlideData);

// // //     return (
// // //         <div style={{
// // //             height: "100vh",
// // //             background: "#ee4b2e",
// // //             //  background: "black",
// // //             color: "#fff",
// // //             padding: "20px",
// // //             position: "relative",
// // //             overflow: "hidden",
// // //             scrollbarWidth: "none",
// // //             textTransform: "uppercase",
// // //             fontFamily: "Arial, Helvetica, sans-serif"
// // //         }}>

// // //             {/* BACK BUTTON */}
// // //             {/* <button
// // //                 onClick={handleBack}
// // //                 style={{
// // //                     position: "absolute",
// // //                     top: 20,
// // //                     left: 20,
// // //                     background: "#8b0000",
// // //                     color: "#fff",
// // //                     border: "none",
// // //                     borderRadius: "50%",
// // //                     width: 50,
// // //                     height: 50,
// // //                     cursor: "pointer",
// // //                     zIndex: 10,
// // //                     display: "flex",
// // //                     alignItems: "center",
// // //                     justifyContent: "center"
// // //                 }}
// // //             >
// // //                 <ArrowBackIcon />
// // //             </button> */}

// // //             {/* SLIDE NUMBER */}
// // //             {/* <div style={{
// // //                 position: "absolute",
// // //                 top: 30,
// // //                 right: 30,
// // //                 fontSize: "1.2rem",
// // //                 zIndex: 10,
// // //                 background: "rgba(0,0,0,0.2)",
// // //                 padding: "5px 15px",
// // //                 borderRadius: "20px",
// // //                 letterSpacing: "1px"
// // //             }}>
// // //                 SLIDE {currentSlide + 1} / {slides.length}
// // //             </div> */}

// // //             {/* 3 COLUMN LAYOUT - NO SCROLLING */}
// // //             <div
// // //                 ref={slideContainerRef}
// // //                 style={{
// // //                     display: "flex",
// // //                     width: "100%",
// // //                     height: "90vh",
// // //                     transition: isTransitioning ? "transform 0.5s ease-in-out" : "none",
// // //                     transform: `translateX(-${currentSlide * 100}%)`,
// // //                     marginTop: "0px"
// // //                 }}
// // //             >
// // //                 {slides.map((slideData, index) => {
// // //                     const columns = distributeItemsToColumns(slideData);

// // //                     return (
// // //                         <div
// // //                             key={index}
// // //                             style={{
// // //                                 minWidth: "100%",
// // //                                 height: "100%",
// // //                                 padding: "0 20px",
// // //                                 marginTop:"10px",
// // //                                 boxSizing: "border-box"
// // //                             }}
// // //                         >
// // //                             {/* 3 COLUMN LAYOUT */}
// // //                             <div style={{
// // //                                 display: "grid",
// // //                                 gridTemplateColumns: "repeat(3, 1fr)",
// // //                                 gap: "40px",
// // //                                 height: "100%",
// // //                                 overflow: "hidden"
// // //                             }}>
// // //                                 {columns.map((column, colIndex) => (
// // //                                     <div 
// // //                                         key={colIndex}
// // //                                         style={{
// // //                                             height: "100%",
// // //                                             overflow: "hidden",
// // //                                             display: "flex",
// // //                                             flexDirection: "column"
// // //                                         }}
// // //                                     >
// // //                                         <div style={{
// // //                                             flex: 1,
// // //                                             overflowY: "hidden",
// // //                                             scrollbarWidth: "none",
// // //                                             msOverflowStyle: "none",
// // //                                             paddingRight: "5px"
// // //                                         }}>
// // //                                             {column.map((item, itemIndex) => {
// // //                                                 if (item.type === "category") {
// // //                                                     return (
// // //                                                         <div
// // //                                                             key={`cat-${colIndex}-${itemIndex}`}
// // //                                                             style={{
// // //                                                                 fontSize: "2rem",
// // //                                                                 fontWeight: "900",
// // //                                                                 margin: "0 0 6px 0",
// // //                                                                 textAlign: "center",
// // //                                                                 color: "#fff",
// // //                                                                 letterSpacing: "2px",
// // //                                                                 textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
// // //                                                                 borderBottom: "0px solid rgba(255,255,255,0.3)",
// // //                                                                 paddingBottom: "4px",
// // //                                                                 lineHeight: "1.2"
// // //                                                             }}
// // //                                                         >
// // //                                                             {item.name}
// // //                                                         </div>
// // //                                                     );
// // //                                                 }

// // //                                                 return (
// // //                                                     <div
// // //                                                         key={item.dishId}
// // //                                                         style={{
// // //                                                             display: "flex",
// // //                                                             justifyContent: "space-between",
// // //                                                             alignItems: "center",
// // //                                                             fontSize: "clamp(0.9rem, 1.5vw, 1.7rem)",
// // //                                                             padding: "3px 0",
// // //                                                             transition: "all 0.2s ease",
// // //                                                             cursor: "default",
// // //                                                             letterSpacing: "0.5px",
// // //                                                             lineHeight: "1.2"
// // //                                                         }}
// // //                                                         // onMouseEnter={(e) => {
// // //                                                         //     e.currentTarget.style.background = "rgba(255,255,255,0.05)";
// // //                                                         //     e.currentTarget.style.paddingLeft = "10px";
// // //                                                         //     e.currentTarget.style.paddingRight = "10px";
// // //                                                         // }}
// // //                                                         // onMouseLeave={(e) => {
// // //                                                         //     e.currentTarget.style.background = "transparent";
// // //                                                         //     e.currentTarget.style.paddingLeft = "0";
// // //                                                         //     e.currentTarget.style.paddingRight = "0";
// // //                                                         // }}
// // //                                                     >
// // //                                                         <span style={{ 
// // //                                                             flex: 1,
// // //                                                             fontWeight: "900",
// // //                                                             whiteSpace: "nowrap",
// // //                                                             overflow: "hidden",
// // //                                                             textOverflow: "ellipsis",
// // //                                                             paddingRight: "15px"
// // //                                                         }}>
// // //                                                             {item.dishName}
// // //                                                         </span>
// // //                                                         <span style={{ 
// // //                                                             fontWeight: "bold",
// // //                                                             color: "#ffd700",
// // //                                                             fontSize: "clamp(1rem, 1.6vw, 1.8rem)",
// // //                                                             whiteSpace: "nowrap"
// // //                                                         }}>
// // //                                                             ₹{item.price}
// // //                                                         </span>
// // //                                                     </div>
// // //                                                 );
// // //                                             })}

// // //                                             {/* Empty space filler */}
// // //                                             {column.length < 15 && [...Array(15 - column.length)].map((_, i) => (
// // //                                                 <div
// // //                                                     key={`empty-${i}`}
// // //                                                     style={{
// // //                                                         height: "calc((100vh - 230px) / 15)",
// // //                                                         opacity: 0,
// // //                                                         pointerEvents: "none"
// // //                                                     }}
// // //                                                 />
// // //                                             ))}
// // //                                         </div>
// // //                                     </div>
// // //                                 ))}
// // //                             </div>
// // //                         </div>
// // //                     );
// // //                 })}
// // //             </div>

// // //             {/* SLIDE INDICATORS */}
// // //             {/* {slides.length > 1 && (
// // //                 <div style={{
// // //                     position: "absolute",
// // //                     bottom: 25,
// // //                     left: "50%",
// // //                     transform: "translateX(-50%)",
// // //                     display: "flex",
// // //                     gap: "15px",
// // //                     zIndex: 10
// // //                 }}>
// // //                     {slides.map((_, index) => (
// // //                         <button
// // //                             key={index}
// // //                             onClick={() => setCurrentSlide(index)}
// // //                             style={{
// // //                                 width: 12,
// // //                                 height: 12,
// // //                                 borderRadius: "50%",
// // //                                 border: "none",
// // //                                 background: index === currentSlide ? "#fff" : "rgba(255,255,255,0.3)",
// // //                                 cursor: "pointer",
// // //                                 transition: "all 0.3s ease",
// // //                                 transform: index === currentSlide ? "scale(1.3)" : "scale(1)"
// // //                             }}
// // //                         />
// // //                     ))}
// // //                 </div>
// // //             )} */}
// // //         </div>
// // //     );
// // // };

// // // export default MenuAdvertisement;






// // import React, { useEffect, useState, useRef } from "react";
// // import { useNavigate } from "react-router-dom";
// // import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// // import axios from "axios";

// // const MenuAdvertisement = () => {
// //     const navigate = useNavigate();
// //       const slideContainerRef = useRef(null);

// //     const [slides, setSlides] = useState([]);
// //     const [currentSlide, setCurrentSlide] = useState(0);
// //     const [loading, setLoading] = useState(true);

// //     const handleBack = () => navigate("/fooddashboard");
// // const [isTransitioning, setIsTransitioning] = useState(false);
// //     // Function to distribute items with exactly 12 items per column
// //     const distributeItemsToColumns = (items) => {
// //         const columns = [[], [], []];
// //         const ITEMS_PER_COLUMN = 18;

// //         let currentColumn = 0;
// //         let currentColumnItems = [];

// //         items.forEach(item => {
// //             // Add item to current column's temporary list
// //             currentColumnItems.push(item);

// //             // If this column has reached 12 items, move to next column
// //             if (currentColumnItems.length === ITEMS_PER_COLUMN) {
// //                 columns[currentColumn] = [...currentColumnItems];
// //                 currentColumnItems = [];
// //                 currentColumn = (currentColumn + 1) % 3;
// //             }
// //         });

// //         // Add remaining items to the last column
// //         if (currentColumnItems.length > 0) {
// //             columns[currentColumn] = [...currentColumnItems];
// //         }

// //         // Ensure all columns have arrays (even if empty)
// //         for (let i = 0; i < 3; i++) {
// //             if (!columns[i]) {
// //                 columns[i] = [];
// //             }
// //         }

// //         return columns;
// //     };

// //     useEffect(() => {
// //         const fetchMenuData = async () => {
// //             const vendorId = localStorage.getItem("vendorId");
// //             const token = localStorage.getItem("authToken");

// //             if (!vendorId || !token) {
// //                 setLoading(false);
// //                 return;
// //             }

// //             try {
// //                 const response = await axios.get(
// //                     `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
// //                     {
// //                         headers: { Authorization: `Bearer ${token}` },
// //                     }
// //                 );

// //                 const allItems = response.data;

// //                 const categories = allItems.filter(i => i.parentId === 0);
// //                 const dishes = allItems.filter(
// //                     i =>
// //                         i.parentId !== 0 &&
// //                         i.menuStatus === "Enable" &&
// //                         i.stockQuantity > 0
// //                 );

// //                 let structuredList = [];

// //                 categories.forEach(category => {
// //                     const categoryItems = dishes.filter(
// //                         d => d.parentId === category.dishId
// //                     );

// //                     if (categoryItems.length > 0) {
// //                         structuredList.push({
// //                             type: "category",
// //                             name: category.dishName.toUpperCase()
// //                         });

// //                         categoryItems.forEach(item => {
// //                             structuredList.push({
// //                                 type: "item",
// //                                 dishName: item.dishName.toUpperCase(),
// //                                 price: item.price,
// //                                 dishId: item.dishId
// //                             });
// //                         });
// //                     }
// //                 });

// //                 // Create slides with 36 items each (3 columns × 12 items)
// //                 const SLIDE_SIZE = 54;
// //                 const generatedSlides = [];

// //                 for (let i = 0; i < structuredList.length; i += SLIDE_SIZE) {
// //                     generatedSlides.push(structuredList.slice(i, i + SLIDE_SIZE));
// //                 }

// //                 setSlides(generatedSlides);
// //                 setLoading(false);

// //             } catch (error) {
// //                 console.error(error);
// //                 setLoading(false);
// //             }
// //         };

// //         fetchMenuData();
// //     }, []);

// //     const goToSlide = (index) => {
// //         if (isTransitioning || index === currentSlide) return;

// //         setIsTransitioning(true);
// //         setCurrentSlide(index);

// //         setTimeout(() => {
// //             setIsTransitioning(false);
// //         }, 500); // Match this with CSS transition duration
// //     };

// //     const nextSlide = () => {
// //         if (slides.length <= 1 || isTransitioning) return;
// //         const nextIndex = currentSlide === slides.length - 1 ? 0 : currentSlide + 1;
// //         goToSlide(nextIndex);
// //     };

// //     const prevSlide = () => {
// //         if (slides.length <= 1 || isTransitioning) return;
// //         const prevIndex = currentSlide === 0 ? slides.length - 1 : currentSlide - 1;
// //         goToSlide(prevIndex);
// //     };

// //     // Auto slide with smooth transition
// //     useEffect(() => {
// //         if (slides.length <= 1) return;

// //         const interval = setInterval(() => {
// //             nextSlide();
// //         }, 10000);

// //         return () => clearInterval(interval);
// //     }, [slides, currentSlide, isTransitioning]);

// //     if (loading) {
// //         return (
// //             <div style={{
// //                 height: "100vh",
// //                 display: "flex",
// //                 justifyContent: "center",
// //                 alignItems: "center",
// //                 fontSize: "2rem",
// //                 // background: "#ee4b2e",
// //                 backgroundColor:"#212529",
// //                 color: "#fff",
// //                 textTransform: "uppercase"
// //             }}>
// //                 LOADING MENU...
// //             </div>
// //         );
// //     }

// //     if (slides.length === 0) {
// //         return (
// //             <div style={{
// //                 height: "100vh",
// //                 display: "flex",
// //                 justifyContent: "center",
// //                 alignItems: "center",
// //                 fontSize: "2rem",
// //                 // background: "#ee4b2e",
// //                 backgroundColor:"black",
// //                 color: "#fff",
// //                 textTransform: "uppercase"
// //             }}>
// //                 NO MENU AVAILABLE
// //             </div>
// //         );
// //     }

// //     const currentSlideData = slides[currentSlide];
// //     const columns = distributeItemsToColumns(currentSlideData);

// //     return (
// //         <div style={{
// //             height: "100vh",
// //             background: "#ee4b2e",
// //             //  background: "black",
// //             color: "#fff",
// //             padding: "20px",
// //             position: "relative",
// //             overflow: "hidden",
// //             scrollbarWidth: "none",
// //             textTransform: "uppercase",
// //             fontFamily: "Arial, Helvetica, sans-serif"
// //         }}>

// //             {/* BACK BUTTON */}
// //             {/* <button
// //                 onClick={handleBack}
// //                 style={{
// //                     position: "absolute",
// //                     top: 20,
// //                     left: 20,
// //                     background: "#8b0000",
// //                     color: "#fff",
// //                     border: "none",
// //                     borderRadius: "50%",
// //                     width: 50,
// //                     height: 50,
// //                     cursor: "pointer",
// //                     zIndex: 10,
// //                     display: "flex",
// //                     alignItems: "center",
// //                     justifyContent: "center"
// //                 }}
// //             >
// //                 <ArrowBackIcon />
// //             </button> */}

// //             {/* SLIDE NUMBER */}
// //             {/* <div style={{
// //                 position: "absolute",
// //                 top: 30,
// //                 right: 30,
// //                 fontSize: "1.2rem",
// //                 zIndex: 10,
// //                 background: "rgba(0,0,0,0.2)",
// //                 padding: "5px 15px",
// //                 borderRadius: "20px",
// //                 letterSpacing: "1px"
// //             }}>
// //                 SLIDE {currentSlide + 1} / {slides.length}
// //             </div> */}

// //             {/* 3 COLUMN LAYOUT - NO SCROLLING */}
// //             <div
// //                 ref={slideContainerRef}
// //                 style={{
// //                     display: "flex",
// //                     width: "100%",
// //                     height: "100vh",
// //                     transition: isTransitioning ? "transform 0.5s ease-in-out" : "none",
// //                     transform: `translateX(-${currentSlide * 100}%)`,
// //                     marginTop: "0px"
// //                 }}
// //             >
// //                 {slides.map((slideData, index) => {
// //                     const columns = distributeItemsToColumns(slideData);

// //                     return (
// //                         <div
// //                             key={index}
// //                             style={{
// //                                 minWidth: "100%",
// //                                 height: "100%",
// //                                 padding: "0 20px",
// //                                 marginTop:"0px",
// //                                 boxSizing: "border-box"
// //                             }}
// //                         >
// //                             {/* 3 COLUMN LAYOUT */}
// //                             <div style={{
// //                                 display: "grid",
// //                                 gridTemplateColumns: "repeat(3, 1fr)",
// //                                 gap: "40px",
// //                                 height: "100%",
// //                                 overflow: "hidden"
// //                             }}>
// //                                 {columns.map((column, colIndex) => (
// //                                     <div 
// //                                         key={colIndex}
// //                                         style={{
// //                                             height: "100%",
// //                                             overflow: "hidden",
// //                                             display: "flex",
// //                                             flexDirection: "column"
// //                                         }}
// //                                     >
// //                                         <div style={{
// //                                             flex: 1,
// //                                             overflowY: "hidden",
// //                                             scrollbarWidth: "none",
// //                                             msOverflowStyle: "none",
// //                                             paddingRight: "5px"
// //                                         }}>
// //                                             {column.map((item, itemIndex) => {
// //                                                 if (item.type === "category") {
// //                                                     return (
// //                                                         <div
// //                                                             key={`cat-${colIndex}-${itemIndex}`}
// //                                                             style={{
// //                                                                 fontSize: "2rem",
// //                                                                 fontWeight: "900",
// //                                                                 margin: "0 0 6px 0",
// //                                                                 textAlign: "center",
// //                                                                 color: "#fff",
// //                                                                 letterSpacing: "2px",
// //                                                                 textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
// //                                                                 borderBottom: "0px solid rgba(255,255,255,0.3)",
// //                                                                 paddingBottom: "4px",
// //                                                                 lineHeight: "1.2"
// //                                                             }}
// //                                                         >
// //                                                             {item.name}
// //                                                         </div>
// //                                                     );
// //                                                 }

// //                                                 return (
// //                                                     <div
// //                                                         key={item.dishId}
// //                                                         style={{
// //                                                             display: "flex",
// //                                                             justifyContent: "space-between",
// //                                                             alignItems: "center",
// //                                                             fontSize: "clamp(0.9rem, 1.5vw, 1.7rem)",
// //                                                             padding: "3px 0",
// //                                                             transition: "all 0.2s ease",
// //                                                             cursor: "default",
// //                                                             letterSpacing: "0.5px",
// //                                                             lineHeight: "1.2"
// //                                                         }}
// //                                                         // onMouseEnter={(e) => {
// //                                                         //     e.currentTarget.style.background = "rgba(255,255,255,0.05)";
// //                                                         //     e.currentTarget.style.paddingLeft = "10px";
// //                                                         //     e.currentTarget.style.paddingRight = "10px";
// //                                                         // }}
// //                                                         // onMouseLeave={(e) => {
// //                                                         //     e.currentTarget.style.background = "transparent";
// //                                                         //     e.currentTarget.style.paddingLeft = "0";
// //                                                         //     e.currentTarget.style.paddingRight = "0";
// //                                                         // }}
// //                                                     >
// //                                                         <span style={{ 
// //                                                             flex: 1,
// //                                                             fontWeight: "900",
// //                                                             whiteSpace: "nowrap",
// //                                                             overflow: "hidden",
// //                                                             textOverflow: "ellipsis",
// //                                                             paddingRight: "15px"
// //                                                         }}>
// //                                                             {item.dishName}
// //                                                         </span>
// //                                                         <span style={{ 
// //                                                             fontWeight: "bold",
// //                                                             color: "#ffd700",
// //                                                             fontSize: "clamp(1rem, 1.6vw, 1.8rem)",
// //                                                             whiteSpace: "nowrap"
// //                                                         }}>
// //                                                             ₹{item.price}
// //                                                         </span>
// //                                                     </div>
// //                                                 );
// //                                             })}

// //                                             {/* Empty space filler */}
// //                                             {column.length < 15 && [...Array(15 - column.length)].map((_, i) => (
// //                                                 <div
// //                                                     key={`empty-${i}`}
// //                                                     style={{
// //                                                         height: "calc((100vh - 230px) / 15)",
// //                                                         opacity: 0,
// //                                                         pointerEvents: "none"
// //                                                     }}
// //                                                 />
// //                                             ))}
// //                                         </div>
// //                                     </div>
// //                                 ))}
// //                             </div>
// //                         </div>
// //                     );
// //                 })}
// //             </div>

// //             {/* SLIDE INDICATORS */}
// //             {/* {slides.length > 1 && (
// //                 <div style={{
// //                     position: "absolute",
// //                     bottom: 25,
// //                     left: "50%",
// //                     transform: "translateX(-50%)",
// //                     display: "flex",
// //                     gap: "15px",
// //                     zIndex: 10
// //                 }}>
// //                     {slides.map((_, index) => (
// //                         <button
// //                             key={index}
// //                             onClick={() => setCurrentSlide(index)}
// //                             style={{
// //                                 width: 12,
// //                                 height: 12,
// //                                 borderRadius: "50%",
// //                                 border: "none",
// //                                 background: index === currentSlide ? "#fff" : "rgba(255,255,255,0.3)",
// //                                 cursor: "pointer",
// //                                 transition: "all 0.3s ease",
// //                                 transform: index === currentSlide ? "scale(1.3)" : "scale(1)"
// //                             }}
// //                         />
// //                     ))}
// //                 </div>
// //             )} */}
// //         </div>
// //     );
// // };

// // export default MenuAdvertisement;




// import React, { useEffect, useState, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import axios from "axios";

// const MenuAdvertisement = () => {
//     const navigate = useNavigate();
//     const slideContainerRef = useRef(null);

//     const [slides, setSlides] = useState([]);
//     const [currentSlide, setCurrentSlide] = useState(0);
//     const [loading, setLoading] = useState(true);

//     const handleBack = () => navigate("/fooddashboard");
//     const [isTransitioning, setIsTransitioning] = useState(false);

//     // Function to distribute items with exactly 12 items per column
//     const distributeItemsToColumns = (items) => {
//         const columns = [[], [], []];
//         const ITEMS_PER_COLUMN = 18;

//         let currentColumn = 0;
//         let currentColumnItems = [];

//         items.forEach(item => {
//             // Add item to current column's temporary list
//             currentColumnItems.push(item);

//             // If this column has reached 12 items, move to next column
//             if (currentColumnItems.length === ITEMS_PER_COLUMN) {
//                 columns[currentColumn] = [...currentColumnItems];
//                 currentColumnItems = [];
//                 currentColumn = (currentColumn + 1) % 3;
//             }
//         });

//         // Add remaining items to the last column
//         if (currentColumnItems.length > 0) {
//             columns[currentColumn] = [...currentColumnItems];
//         }

//         // Ensure all columns have arrays (even if empty)
//         for (let i = 0; i < 3; i++) {
//             if (!columns[i]) {
//                 columns[i] = [];
//             }
//         }

//         return columns;
//     };

//     useEffect(() => {
//         const fetchMenuData = async () => {
//             const vendorId = localStorage.getItem("vendorId");
//             const token = localStorage.getItem("authToken");

//             if (!vendorId || !token) {
//                 setLoading(false);
//                 return;
//             }

//             try {
//                 const response = await axios.get(
//                     `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
//                     {
//                         headers: { Authorization: `Bearer ${token}` },
//                     }
//                 );

//                 const allItems = response.data;

//                 const categories = allItems.filter(i => i.parentId === 0);
//                 const dishes = allItems.filter(
//                     i =>
//                         i.parentId !== 0 &&
//                         i.menuStatus === "Enable" &&
//                         i.stockQuantity > 0
//                 );

//                 let structuredList = [];

//                 categories.forEach(category => {
//                     const categoryItems = dishes.filter(
//                         d => d.parentId === category.dishId
//                     );

//                     if (categoryItems.length > 0) {
//                         structuredList.push({
//                             type: "category",
//                             name: category.dishName.toUpperCase()
//                         });

//                         categoryItems.forEach(item => {
//                             structuredList.push({
//                                 type: "item",
//                                 dishName: item.dishName.toUpperCase(),
//                                 price: item.price,
//                                 dishId: item.dishId,
//                                 tag: item.tag // Make sure to include the tag
//                             });
//                         });
//                     }
//                 });

//                 // Create slides with 54 items each (3 columns × 18 items? - you had 36 earlier but code says 54)
//                 const SLIDE_SIZE = 54;
//                 const generatedSlides = [];

//                 for (let i = 0; i < structuredList.length; i += SLIDE_SIZE) {
//                     generatedSlides.push(structuredList.slice(i, i + SLIDE_SIZE));
//                 }

//                 setSlides(generatedSlides);
//                 setLoading(false);

//             } catch (error) {
//                 console.error(error);
//                 setLoading(false);
//             }
//         };

//         // Initial fetch
//         fetchMenuData();

//         // Set up interval to refresh every 60 seconds (1 minute)
//         const intervalId = setInterval(fetchMenuData, 20000); // 60000 ms = 1 minute

//         // Cleanup function to clear interval when component unmounts
//         return () => clearInterval(intervalId);

//     }, []); // Empty dependency array means this runs once on mount

//     const goToSlide = (index) => {
//         if (isTransitioning || index === currentSlide) return;

//         setIsTransitioning(true);
//         setCurrentSlide(index);

//         setTimeout(() => {
//             setIsTransitioning(false);
//         }, 500);
//     };

//     const nextSlide = () => {
//         if (slides.length <= 1 || isTransitioning) return;
//         const nextIndex = currentSlide === slides.length - 1 ? 0 : currentSlide + 1;
//         goToSlide(nextIndex);
//     };

//     const prevSlide = () => {
//         if (slides.length <= 1 || isTransitioning) return;
//         const prevIndex = currentSlide === 0 ? slides.length - 1 : currentSlide - 1;
//         goToSlide(prevIndex);
//     };

//     // Auto slide with smooth transition
//     useEffect(() => {
//         if (slides.length <= 1) return;

//         const interval = setInterval(() => {
//             nextSlide();
//         }, 10000);

//         return () => clearInterval(interval);
//     }, [slides, currentSlide, isTransitioning]);

//     if (loading) {
//         return (
//             <div style={{
//                 height: "100vh",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 fontSize: "2rem",
//                 backgroundColor: "#212529",
//                 color: "#fff",
//                 textTransform: "uppercase"
//             }}>
//                 LOADING MENU...
//             </div>
//         );
//     }

//     if (slides.length === 0) {
//         return (
//             <div style={{
//                 height: "100vh",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 fontSize: "2rem",
//                 backgroundColor: "#ee4b2e",
//                 color: "#fff",
//                 textTransform: "uppercase"
//             }}>
//                 NO MENU AVAILABLE
//             </div>
//         );
//     }

//     const currentSlideData = slides[currentSlide];
//     const columns = distributeItemsToColumns(currentSlideData);

//     // Helper function to render veg/non-veg indicator
//     const renderVegNonVegIndicator = (tag) => {
//         if (tag === "Veg") {
//             return (
//                 <span style={{
//                     display: "inline-flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     width: "clamp(16px, 2vw, 24px)",
//                     height: "clamp(16px, 2vw, 24px)",
//                     border: "2px solid #4caf50",
//                     borderRadius: "4px",
//                     marginRight: "8px",
//                     position: "relative",
//                     backgroundColor: "#fff",
//                     flexShrink: 0
//                 }}>
//                     <span style={{
//                         width: "clamp(8px, 1vw, 12px)",
//                         height: "clamp(8px, 1vw, 12px)",
//                         backgroundColor: "#4caf50",
//                         borderRadius: "50%",
//                         position: "absolute",
//                         top: "50%",
//                         left: "50%",
//                         transform: "translate(-50%, -50%)"
//                     }} />
//                 </span>
//             );
//         } else if (tag === "Non_Veg") {
//             return (
//                 <span style={{
//                     display: "inline-flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     width: "clamp(16px, 2vw, 24px)",
//                     height: "clamp(16px, 2vw, 24px)",
//                     border: "2px solid #f44336",
//                     borderRadius: "4px",
//                     marginRight: "8px",
//                     position: "relative",
//                     backgroundColor: "#fff",
//                     flexShrink: 0
//                 }}>
//                     <span style={{
//                         width: "clamp(8px, 1vw, 12px)",
//                         height: "clamp(8px, 1vw, 12px)",
//                         backgroundColor: "#f44336",
//                         borderRadius: "50%",
//                         position: "absolute",
//                         top: "50%",
//                         left: "50%",
//                         transform: "translate(-50%, -50%)"
//                     }} />
//                 </span>
//             );
//         }
//         return null;
//     };

//     return (
//         <div style={{
//             height: "100vh",
//             background: "#ee4b2e",
//             color: "#fff",
//             padding: "20px",
//             position: "relative",
//             overflow: "hidden",
//             scrollbarWidth: "none",
//             textTransform: "uppercase",
//             fontFamily: "Arial, Helvetica, sans-serif"
//         }}>

//             {/* 3 COLUMN LAYOUT - NO SCROLLING */}
//             <div
//                 ref={slideContainerRef}
//                 style={{
//                     display: "flex",
//                     width: "100%",
//                     height: "100vh",
//                     transition: isTransitioning ? "transform 0.5s ease-in-out" : "none",
//                     transform: `translateX(-${currentSlide * 100}%)`,
//                     marginTop: "0px"
//                 }}
//             >
//                 {slides.map((slideData, index) => {
//                     const columns = distributeItemsToColumns(slideData);

//                     return (
//                         <div
//                             key={index}
//                             style={{
//                                 minWidth: "100%",
//                                 height: "100%",
//                                 padding: "0 20px",
//                                 marginTop: "0px",
//                                 boxSizing: "border-box"
//                             }}
//                         >
//                             {/* 3 COLUMN LAYOUT */}
//                             <div style={{
//                                 display: "grid",
//                                 gridTemplateColumns: "repeat(3, 1fr)",
//                                 gap: "40px",
//                                 height: "100%",
//                                 overflow: "hidden"
//                             }}>
//                                 {columns.map((column, colIndex) => (
//                                     <div
//                                         key={colIndex}
//                                         style={{
//                                             height: "100%",
//                                             overflow: "hidden",
//                                             display: "flex",
//                                             flexDirection: "column"
//                                         }}
//                                     >
//                                         <div style={{
//                                             flex: 1,
//                                             overflowY: "hidden",
//                                             scrollbarWidth: "none",
//                                             msOverflowStyle: "none",
//                                             paddingRight: "5px"
//                                         }}>
//                                             {column.map((item, itemIndex) => {
//                                                 if (item.type === "category") {
//                                                     return (
//                                                         <div
//                                                             key={`cat-${colIndex}-${itemIndex}`}
//                                                             style={{
//                                                                 fontSize: "2rem",
//                                                                 fontWeight: "900",
//                                                                 margin: "0 0 6px 0",
//                                                                 textAlign: "center",
//                                                                 color: "#fff",
//                                                                 letterSpacing: "2px",
//                                                                 textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
//                                                                 borderBottom: "0px solid rgba(255,255,255,0.3)",
//                                                                 paddingBottom: "4px",
//                                                                 lineHeight: "1.2"
//                                                             }}
//                                                         >
//                                                             {item.name}
//                                                         </div>
//                                                     );
//                                                 }

//                                                 return (
//                                                     <div
//                                                         key={item.dishId}
//                                                         style={{
//                                                             display: "flex",
//                                                             justifyContent: "space-between",
//                                                             alignItems: "center",
//                                                             fontSize: "clamp(0.9rem, 1.5vw, 1.7rem)",
//                                                             padding: "3px 0",
//                                                             transition: "all 0.2s ease",
//                                                             cursor: "default",
//                                                             letterSpacing: "0.5px",
//                                                             lineHeight: "1.2"
//                                                         }}
//                                                     >
//                                                         <div style={{
//                                                             display: "flex",
//                                                             alignItems: "center",
//                                                             flex: 1,
//                                                             minWidth: 0 // Allows text truncation to work
//                                                         }}>
//                                                             {/* Veg/Non-veg indicator */}
//                                                             {renderVegNonVegIndicator(item.tag)}

//                                                             <span style={{
//                                                                 fontWeight: "900",
//                                                                 whiteSpace: "nowrap",
//                                                                 overflow: "hidden",
//                                                                 textOverflow: "ellipsis",
//                                                                 paddingRight: "15px"
//                                                             }}>
//                                                                 {item.dishName}
//                                                             </span>
//                                                         </div>

//                                                         <span style={{
//                                                             fontWeight: "bold",
//                                                             // color: "#ffd700",
//                                                             color: "rgb(110 255 143)",
//                                                             fontSize: "clamp(1rem, 1.6vw, 1.8rem)",
//                                                             whiteSpace: "nowrap",
//                                                             flexShrink: 0
//                                                         }}>
//                                                             ₹{item.price}
//                                                         </span>
//                                                     </div>
//                                                 );
//                                             })}

//                                             {/* Empty space filler */}
//                                             {column.length < 15 && [...Array(15 - column.length)].map((_, i) => (
//                                                 <div
//                                                     key={`empty-${i}`}
//                                                     style={{
//                                                         height: "calc((100vh - 230px) / 15)",
//                                                         opacity: 0,
//                                                         pointerEvents: "none"
//                                                     }}
//                                                 />
//                                             ))}
//                                         </div>
//                                     </div>
//                                 ))}
//                             </div>
//                         </div>
//                     );
//                 })}
//             </div>
//         </div>
//     );
// };

// export default MenuAdvertisement;




import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import axios from "axios";

const MenuAdvertisement = () => {
    const navigate = useNavigate();
    const slideContainerRef = useRef(null);

    const [slides, setSlides] = useState([]);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [loading, setLoading] = useState(true);

    const handleBack = () => navigate("/fooddashboard");
    const [isTransitioning, setIsTransitioning] = useState(false);

    // Function to distribute items with exactly 12 items per column
    const distributeItemsToColumns = (items) => {
        const columns = [[], [], []];
        const ITEMS_PER_COLUMN = 18;

        let currentColumn = 0;
        let currentColumnItems = [];

        items.forEach(item => {
            // Add item to current column's temporary list
            currentColumnItems.push(item);

            // If this column has reached 12 items, move to next column
            if (currentColumnItems.length === ITEMS_PER_COLUMN) {
                columns[currentColumn] = [...currentColumnItems];
                currentColumnItems = [];
                currentColumn = (currentColumn + 1) % 3;
            }
        });

        // Add remaining items to the last column
        if (currentColumnItems.length > 0) {
            columns[currentColumn] = [...currentColumnItems];
        }

        // Ensure all columns have arrays (even if empty)
        for (let i = 0; i < 3; i++) {
            if (!columns[i]) {
                columns[i] = [];
            }
        }

        return columns;
    };

    useEffect(() => {
        const fetchMenuData = async () => {
            const vendorId = localStorage.getItem("vendorId");
            const token = localStorage.getItem("authToken");

            if (!vendorId || !token) {
                setLoading(false);
                return;
            }

            try {
                const response = await axios.get(
                    `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );

                const allItems = response.data;

                const categories = allItems.filter(i => i.parentId === 0);
                const dishes = allItems.filter(
                    i =>
                        i.parentId !== 0 &&
                        i.menuStatus === "Enable" &&
                        i.stockQuantity > 0
                );

                let structuredList = [];

                categories.forEach(category => {
                    const categoryItems = dishes.filter(
                        d => d.parentId === category.dishId
                    );

                    if (categoryItems.length > 0) {
                        structuredList.push({
                            type: "category",
                            // name: category.dishName.toUpperCase()
                        });

                        // Separate Veg and Non-Veg
                        const vegItems = categoryItems.filter(item => item.tag === "Veg");
                        const nonVegItems = categoryItems.filter(item => item.tag === "Non_Veg");

                        // Push category title
                        structuredList.push({
                            type: "category",
                            name: category.dishName.toUpperCase()
                        });

                        // Push Veg items first
                        vegItems.forEach(item => {
                            structuredList.push({
                                type: "item",
                                dishName: item.dishName.toUpperCase(),
                                price: item.price,
                                dishId: item.dishId,
                                tag: item.tag
                            });
                        });

                        // Then push Non-Veg items
                        nonVegItems.forEach(item => {
                            structuredList.push({
                                type: "item",
                                dishName: item.dishName.toUpperCase(),
                                price: item.price,
                                dishId: item.dishId,
                                tag: item.tag
                            });
                        });

                    }
                });

                // Create slides with 54 items each (3 columns × 18 items? - you had 36 earlier but code says 54)
                const SLIDE_SIZE = 54;
                const generatedSlides = [];

                for (let i = 0; i < structuredList.length; i += SLIDE_SIZE) {
                    generatedSlides.push(structuredList.slice(i, i + SLIDE_SIZE));
                }

                setSlides(generatedSlides);
                setLoading(false);

            } catch (error) {
                console.error(error);
                setLoading(false);
            }
        };

        // Initial fetch
        fetchMenuData();

        // Set up interval to refresh every 60 seconds (1 minute)
        const intervalId = setInterval(fetchMenuData, 20000); // 60000 ms = 1 minute

        // Cleanup function to clear interval when component unmounts
        return () => clearInterval(intervalId);

    }, []); // Empty dependency array means this runs once on mount

    const goToSlide = (index) => {
        if (isTransitioning || index === currentSlide) return;

        setIsTransitioning(true);
        setCurrentSlide(index);

        setTimeout(() => {
            setIsTransitioning(false);
        }, 500);
    };

    const nextSlide = () => {
        if (slides.length <= 1 || isTransitioning) return;
        const nextIndex = currentSlide === slides.length - 1 ? 0 : currentSlide + 1;
        goToSlide(nextIndex);
    };

    const prevSlide = () => {
        if (slides.length <= 1 || isTransitioning) return;
        const prevIndex = currentSlide === 0 ? slides.length - 1 : currentSlide - 1;
        goToSlide(prevIndex);
    };

    // Auto slide with smooth transition
    useEffect(() => {
        if (slides.length <= 1) return;

        const interval = setInterval(() => {
            nextSlide();
        }, 10000);

        return () => clearInterval(interval);
    }, [slides, currentSlide, isTransitioning]);

    if (loading) {
        return (
            <div style={{
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "2rem",
                backgroundColor: "#212529",
                color: "#fff",
                textTransform: "uppercase"
            }}>
                LOADING MENU...
            </div>
        );
    }

    if (slides.length === 0) {
        return (
            <div style={{
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "2rem",
                backgroundColor: "#ee4b2e",
                color: "#fff",
                textTransform: "uppercase"
            }}>
                NO MENU AVAILABLE
            </div>
        );
    }

    const currentSlideData = slides[currentSlide];
    const columns = distributeItemsToColumns(currentSlideData);

    // Helper function to render veg/non-veg indicator
    const renderVegNonVegIndicator = (tag) => {
        if (tag === "Veg") {
            return (
                <span style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "clamp(16px, 2vw, 24px)",
                    height: "clamp(16px, 2vw, 24px)",
                    border: "2px solid #4caf50",
                    borderRadius: "4px",
                    marginRight: "8px",
                    position: "relative",
                    backgroundColor: "#fff",
                    flexShrink: 0
                }}>
                    <span style={{
                        width: "clamp(8px, 1vw, 12px)",
                        height: "clamp(8px, 1vw, 12px)",
                        backgroundColor: "#4caf50",
                        borderRadius: "50%",
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)"
                    }} />
                </span>
            );
        } else if (tag === "Non_Veg") {
            return (
                <span style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "clamp(16px, 2vw, 24px)",
                    height: "clamp(16px, 2vw, 24px)",
                    border: "2px solid #f44336",
                    borderRadius: "4px",
                    marginRight: "8px",
                    position: "relative",
                    backgroundColor: "#fff",
                    flexShrink: 0
                }}>
                    <span style={{
                        width: "clamp(8px, 1vw, 12px)",
                        height: "clamp(8px, 1vw, 12px)",
                        backgroundColor: "#f44336",
                        borderRadius: "50%",
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)"
                    }} />
                </span>
            );
        }
        return null;
    };

    return (
        <div style={{
            height: "100vh",
            background: "#ee4b2e",
            color: "#fff",
            padding: "20px",
            position: "relative",
            overflow: "hidden",
            scrollbarWidth: "none",
            textTransform: "uppercase",
            fontFamily: "Arial, Helvetica, sans-serif"
        }}>

            {/* 3 COLUMN LAYOUT - NO SCROLLING */}
            <div
                ref={slideContainerRef}
                style={{
                    display: "flex",
                    width: "100%",
                    height: "100vh",
                    transition: isTransitioning ? "transform 0.5s ease-in-out" : "none",
                    transform: `translateX(-${currentSlide * 100}%)`,
                    marginTop: "0px"
                }}
            >
                {slides.map((slideData, index) => {
                    const columns = distributeItemsToColumns(slideData);

                    return (
                        <div
                            key={index}
                            style={{
                                minWidth: "100%",
                                height: "100%",
                                padding: "0 20px",
                                marginTop: "0px",
                                boxSizing: "border-box"
                            }}
                        >
                            {/* 3 COLUMN LAYOUT */}
                            <div style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(3, 1fr)",
                                gap: "40px",
                                height: "100%",
                                overflow: "hidden"
                            }}>
                                {columns.map((column, colIndex) => (
                                    <div
                                        key={colIndex}
                                        style={{
                                            height: "100%",
                                            overflow: "hidden",
                                            display: "flex",
                                            flexDirection: "column"
                                        }}
                                    >
                                        <div style={{
                                            flex: 1,
                                            overflowY: "hidden",
                                            scrollbarWidth: "none",
                                            msOverflowStyle: "none",
                                            paddingRight: "5px"
                                        }}>
                                            {column.map((item, itemIndex) => {
                                                if (item.type === "category") {
                                                    return (
                                                        <div
                                                            key={`cat-${colIndex}-${itemIndex}`}
                                                            style={{
                                                                fontSize: "2rem",
                                                                fontWeight: "900",
                                                                margin: "0 0 6px 0",
                                                                textAlign: "center",
                                                                color: "#fff",
                                                                letterSpacing: "2px",
                                                                textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
                                                                borderBottom: "0px solid rgba(255,255,255,0.3)",
                                                                paddingBottom: "4px",
                                                                lineHeight: "1.2"
                                                            }}
                                                        >
                                                            {item.name}
                                                        </div>
                                                    );
                                                }

                                                return (
                                                    <div
                                                        key={item.dishId}
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            alignItems: "center",
                                                            fontSize: "clamp(0.9rem, 1.5vw, 1.7rem)",
                                                            padding: "3px 0",
                                                            transition: "all 0.2s ease",
                                                            cursor: "default",
                                                            letterSpacing: "0.5px",
                                                            lineHeight: "1.2"
                                                        }}
                                                    >
                                                        <div style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            flex: 1,
                                                            minWidth: 0 // Allows text truncation to work
                                                        }}>
                                                            {/* Veg/Non-veg indicator */}
                                                            {renderVegNonVegIndicator(item.tag)}

                                                            <span style={{
                                                                fontWeight: "900",
                                                                whiteSpace: "nowrap",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                paddingRight: "15px"
                                                            }}>
                                                                {item.dishName}
                                                            </span>
                                                        </div>

                                                        <span style={{
                                                            fontWeight: "bold",
                                                            // color: "#ffd700",
                                                            color: "rgb(110 255 143)",
                                                            fontSize: "clamp(1rem, 1.6vw, 1.8rem)",
                                                            whiteSpace: "nowrap",
                                                            flexShrink: 0
                                                        }}>
                                                            ₹{item.price}
                                                        </span>
                                                    </div>
                                                );
                                            })}

                                            {/* Empty space filler */}
                                            {column.length < 15 && [...Array(15 - column.length)].map((_, i) => (
                                                <div
                                                    key={`empty-${i}`}
                                                    style={{
                                                        height: "calc((100vh - 230px) / 15)",
                                                        opacity: 0,
                                                        pointerEvents: "none"
                                                    }}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default MenuAdvertisement;